import React from "react";
import { useDispatch } from "react-redux";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import BSL_Button from "../components/BSL_Button";
import BSL_TextInput from "../components/BSL_TextInput";
import { fetchTimeout, GetHTMLColour, toNumber } from "../components/Common";
import { Palette, API_BASE } from "../AppConfig";
import SegmentedButtonGroup from "../components/SegmentedButtonGroup";
import { Chip, IconButton, LinearProgress, Paper, Popper } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ErrorIcon from "@material-ui/icons/Error";
import CloseIcon from "@material-ui/icons/Close";
import WarningIcon from "@material-ui/icons/Warning";
import DeleteIcon from "@material-ui/icons/Delete";
import RemoveIcon from "@material-ui/icons/Remove";
import AddIcon from "@material-ui/icons/Add";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import "react-json-view-lite/dist/index.css";

// import PRICEFILE from "../bin/PRICE_FILE";
import Draggable from "react-draggable";
import Autocomplete from "react-autocomplete";

import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import ManageMaterialsSpans from "./ManageMaterialsSpans";
import BSL_ControlContainer from "../components/BSL_ControlContainer";
import BSL_Slider from "../components/BSL_Slider";
import { ChromePicker } from "react-color";
import ColourChip from "../components/ColourChip";

const useStyles = makeStyles((theme) => ({
    root: {
        // width: "98%",
        display: "flex",
        flexDirection: "column",
        // height: "90%",
        // overflow: "scroll",
        // fontSize: "small",
    },
    container: {
        height: "90vh",
        maxHeight: "calc(100vh - 175px)",
    },
    row: {
        "tr:hover": {
            backgroundColor: "rgb(7, 50, 50, 0.42)",
        },
    },
    rowCell: {
        fontSize: "12px",
        border: "none",
        padding: "2px 0px 2px 24px",
        color: theme.brand.FIELDERS ? "inherit" : Palette.Lysaght.MidGrey,
        "&:hover": {
            backgroundColor: "rgb(7, 177, 77, 0.42)",
            cursor: "pointer",
        },
    },
    categoryHeadingCell: {
        textAlign: "center",
        backgroundColor: Palette.FieldersOrange + " !important",
        padding: "2px !important",
        borderTopLeftRadius: "5px",
        borderTopRightRadius: "5px",
        borderLeft: "1px solid white !important",
        borderRight: "1px solid white !important",
        position: "sticky",
        top: "0px !important",
    },
    categoryHeadingCellBlank: {
        textAlign: "center",
        backgroundColor: "#ffffff !important",
        padding: "2px !important",
        position: "sticky",
        top: "0px !important",
    },
    headingCell: {
        fontSize: "11px",
        border: "none",
        padding: "2px 0px 2px 24px",
        textTransform: "uppercase",
        color: "#ffffff",
        fontWeight: theme.brand.FIELDERS ? "inherit" : "600",
        fontFamily: theme.typography.fontFamilySecondary,
        backgroundColor: Palette.FieldersBlue,
        lineHeight: "normal",
        zIndex: "5",
        top: "15px",
    },
    headingRow: {
        backgroundColor: Palette.FieldersBlue,
    },
    drag_bar: {
        width: "30px",
        height: "1px",
        marginBottom: "1px",
        background: "#00000030",
    },
    moreButton: {
        padding: "0px",
        borderRadius: "0%",
    },
}));

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
    };
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const default_cad_settings_columns = () => [
    {
        id: "Key",
        label: "Key",
        style: {
            width: "100px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
        headerStyle: {
            width: "100px",
            minWidth: "100px",
            position: "sticky",
            left: "0",
            zIndex: "6",
            fontWeight: "600",
        },
    },
    {
        id: "Value",
        label: "Value",
        format: (value, row) => {
            return (
                <span style={{ background: value, color: row.Contrast, padding: "5px 10px", borderRadius: "29px" }}>
                    {value} {row.SystemDefault ? " (System Default Value: " + row.SystemDefault + ")" : ""}
                </span>
            );
        },
    },
];
const colour_columns = (productlist_autocompleteOptions, colourMapKeys, colourArrayKeys) => [
    {
        id: "Key",
        label: "Key",
        style: {
            width: "100px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
        headerStyle: {
            width: "100px",
            minWidth: "100px",
            position: "sticky",
            left: "0",
            zIndex: "6",
            fontWeight: "600",
        },
    },
    {
        id: "Col1",
        label: "Colour 1 (or topside)",
        grouping: "Specifications",
        format: (value, row) => {
            return (
                <span style={{ background: value, color: row.Contrast, padding: "5px 10px", borderRadius: "29px" }}>
                    {value}
                </span>
            );
        },
        editor: (section, key, row, value, setValue, saveValue) => {
            return (
                <>
                    <div
                        style={{
                            marginTop: "29px 0px 5px 0px",
                            background: value,
                            width: "223px",
                            height: "24px",
                            borderRadius: "29px",
                        }}
                    ></div>
                    <ChromePicker
                        disableAlpha={true}
                        color={value}
                        onChange={(colour) => setValue(colour.hex)}
                        // presetColors={colour_presets}
                    />

                    <BSL_Button onClick={() => saveValue(section, key, row, "Col1", value)}>UPDATE</BSL_Button>
                </>
            );
        },
        style: {
            width: "50px",
        },
    },
    {
        id: "Col2",
        label: "Colour 2 (or bottomside)",
        grouping: "Specifications",
        format: (value, row) => {
            return (
                <span style={{ background: value, color: row.Contrast, padding: "5px 10px", borderRadius: "29px" }}>
                    {value}
                </span>
            );
        },
        editor: (section, key, row, value, setValue, saveValue) => {
            return (
                <>
                    {/* <BSL_ColourSelector
                        custom_select
                        tight
                        mini
                        label="Colour 2 (or bottomside)"
                        // colourList={selectedInfillFront?.colours}
                        value={value}
                        style={{ flex: "none" }}
                        onClose={(colour) => setValue(colour)}
                        onChange={(colour) => setValue(colour)}
                    /> */}
                    <div
                        style={{
                            marginTop: "29px 0px 5px 0px",
                            background: value,
                            width: "223px",
                            height: "24px",
                            borderRadius: "29px",
                        }}
                    ></div>
                    <ChromePicker
                        disableAlpha={true}
                        color={value}
                        onChange={(colour) => setValue(colour.hex)}
                        // presetColors={colour_presets}
                    />

                    <BSL_Button onClick={() => saveValue(section, key, row, "Col2", value)}>UPDATE</BSL_Button>
                </>
            );
        },
        style: {
            width: "50px",
        },
    },
    {
        id: "Contrast",
        label: "Contrast",
        grouping: "Specifications",
        editor: (section, key, row, value, setValue, saveValue) => {
            return (
                <>
                    <div
                        style={{
                            marginTop: "29px 0px 5px 0px",
                            background: value,
                            width: "223px",
                            height: "24px",
                            borderRadius: "29px",
                        }}
                    ></div>
                    <ChromePicker
                        disableAlpha={true}
                        color={value}
                        onChange={(colour) => setValue(colour.hex)}
                        // presetColors={colour_presets}
                    />

                    <BSL_Button onClick={() => saveValue(section, key, row, "Contrast", value)}>UPDATE</BSL_Button>
                </>
            );
        },
        style: {
            width: "50px",
        },
    },
    {
        id: "Opacity",
        label: "Opacity",
        grouping: "Specifications",
        format: (value, row) => {
            return value * 100 + "%";
        },
        editor: (section, key, row, value, setValue, saveValue) => {
            return (
                <>
                    <BSL_Slider
                        label={"Opacity"}
                        style={{ width: "300px" }}
                        tight
                        value={value * 100}
                        min={0}
                        max={100}
                        suffix={"%"}
                        marks={[
                            {
                                value: 0,
                                label: "0%",
                            },
                            {
                                value: 25,
                            },
                            {
                                value: 50,
                                label: "50%",
                            },
                            {
                                value: 75,
                            },
                            {
                                value: 100,
                                label: "100%",
                            },
                        ]}
                        step={1}
                        onChange={(e, val) => {
                            setValue(val / 100);
                        }}
                        onChangeStep={(e, val) => {
                            setValue(val / 100);
                        }}
                    />

                    <BSL_Button onClick={() => saveValue(section, key, row, "Opacity", value)}>UPDATE</BSL_Button>
                </>
            );
        },
        style: {
            width: "50px",
        },
    },
    {
        id: "Code",
        label: "Code",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
    },
];

const colour_default = {
    Col1: "#FFFFFF",
    Col2: "#FFFFFF",
    Contrast: "#000000",
    Opacity: 1,
    Code: "",
};

const colour_array_columns = (productlist_autocompleteOptions, colourMapKeys, colourArrayKeys) => [
    {
        id: "Key",
        label: "Key",
        style: {
            width: "100px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
        headerStyle: {
            width: "100px",
            minWidth: "100px",
            position: "sticky",
            left: "0",
            zIndex: "6",
            fontWeight: "600",
        },
    },
    {
        id: "ARRAY_DATA",
        label: "Colours",
        grouping: "Specifications",
        style: {
            width: "80%",
        },
        format: (value) => {
            if (value && colourMapKeys && colourArrayKeys) {
                let list = value;
                let output = [];
                for (let colour of list) {
                    var top_bg_colour = GetHTMLColour(colour)[0];
                    var bottom_bg2_colour = GetHTMLColour(colour)[1];
                    var contrast = GetHTMLColour(colour)[2];
                    let background = top_bg_colour;
                    if (top_bg_colour === bottom_bg2_colour) background = top_bg_colour;
                    else
                        background =
                            "linear-gradient(135deg, " + top_bg_colour + " 50%, " + bottom_bg2_colour + " 50%)";

                    if (colourMapKeys.includes(colour.trim()))
                        output.push(
                            <>
                                {/* <span
                                style={{
                                    color: contrast,
                                    background: background,
                                    padding: "2px 2px",
                                    borderRadius: "15px",
                                    width: "20px"
                                    height: "20px"
                                }}
                            >
                            </span> */}
                                <ColourChip
                                    className="colour-chip"
                                    colour={colour}
                                    width="1rem"
                                    style={{ background: "#00000000", margin: "0px 5px 0px 10px" }}
                                />
                                {colour}
                            </>
                        );
                    else
                        output.push(
                            <span style={{ color: "orange" }}>
                                {(output.length === 0 ? "" : ",") + colour}{" "}
                                <WarningIcon
                                    style={{
                                        width: "17px",
                                        height: "13px",
                                        color: "#e29d35",
                                    }}
                                />
                            </span>
                        );
                }
                return output;
            }
            return "";
        },
        editor: (
            section,
            key,
            row,
            value,
            setValue,
            saveValue,
            value2,
            setValue2,
            not_used,
            materials,
            setEditItem
        ) => {
            let original_value = JSON.stringify(value);

            let colour_keys = [...Object.keys(materials.colour_map)];
            let value_colours = value;
            let colours_chips = [];
            for (let colour of value_colours) {
                colours_chips.push(
                    <>
                        <Chip
                            style={{ background: "#00000000", height: "20px" }}
                            label={
                                <>
                                    <ColourChip
                                        className="colour-chip"
                                        colour={colour.trim()}
                                        width="1rem"
                                        style={{ background: "#00000000" }}
                                    />
                                    <span style={{ marginLeft: "5px", fontSize: "13px" }}>{colour}</span>
                                </>
                            }
                            onDelete={() => {
                                const filteredItems = value.filter((item) => item !== colour);
                                setValue(filteredItems);
                            }}
                        />
                        <br />
                    </>
                );
            }

            let helperText = [];
            helperText.push(
                <>
                    <b>currently: </b>
                    {original_value}
                    <br />
                </>
            );

            return (
                <BSL_ControlContainer label={"Edit Colour Array: " + key} tight={true}>
                    <div style={{ width: "100%", textAlign: "left" }}>{colours_chips}</div>
                    <Autocomplete
                        items={colour_keys}
                        shouldItemRender={(item, value) => {
                            if (item === null || item === undefined || value === null) return true;
                            if (item.toLowerCase().startsWith(value.toLowerCase().substring(0, 3))) return true;
                            if (item.toLowerCase().indexOf(value.toLowerCase()) > -1) return true;
                            return false;
                        }}
                        autoHighlight={false}
                        getItemValue={(item) => item}
                        renderItem={(item, highlighted) => (
                            <div key={item.id} style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}>
                                {item}
                            </div>
                        )}
                        wrapperStyle={{
                            zIndex: "999999",
                        }}
                        menuStyle={{
                            zIndex: "999999",
                            position: "absolute",
                            backgroundColor: "whitesmoke",
                            boxShadow: "1px 1px 4px",
                            fontSize: "12px",
                            left: "auto",
                            top: "auto",
                            marginLeft: "9px",
                            marginTop: "-21px",
                            textAlign: "left",
                            maxHeight: "250px",
                            overflowY: "auto",
                            color: "black",
                        }}
                        inputProps={{
                            style: {
                                zIndex: "999999",
                                font: "200 12px Univers45",
                                width: "95%",
                                padding: "4px 0px 4px 8px !important",
                            },
                        }}
                        renderInput={(props) => {
                            return (
                                <BSL_TextInput
                                    label={"Add New Colour"}
                                    style={{ width: "300px", color: "white" }}
                                    value={value2}
                                    tight={true}
                                    onEnter={(e) => {
                                        let new_value = [...value];
                                        new_value.push(e.target.value);
                                        setValue(new_value);
                                        setValue2("");
                                    }}
                                    onChange={(value) => {
                                        setValue2(value);
                                    }}
                                    InputProps={{
                                        style: { fontSize: "80%" },
                                        ...props,
                                    }}
                                    helperText={helperText}
                                    helperTextStyle={
                                        helperText.length > 0
                                            ? {
                                                  whiteSpace: "break-spaces",
                                                  backgroundColor: "#ffe7c3",
                                                  padding: "5px",
                                                  borderRadius: "5px",
                                              }
                                            : {}
                                    }
                                />
                            );
                        }}
                        value={value2}
                        onChange={(e) => setValue2(e.target.value)}
                        onSelect={(val) => {
                            let new_value = [...value];
                            new_value.push(val);
                            setValue(new_value);
                            setValue2("");
                        }}
                    />
                    <BSL_Button onClick={() => saveValue(section, key, value, "ARRAY_DATA")}>UPDATE</BSL_Button>
                </BSL_ControlContainer>
            );
        },
    },
];

const slat_columns = (productlist_autocompleteOptions, colourMapKeys, colourArrayKeys) => [
    {
        id: "Key",
        label: "Key",
        style: {
            width: "100px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
        headerStyle: {
            width: "160px",
            minWidth: "160px",
            position: "sticky",
            left: "0",
            zIndex: "6",
            fontWeight: "600",
        },
    },
    {
        id: "Name",
        label: "Name (Offering ID)",
        style: {
            width: "100px",
        },
    },
    {
        id: "Width",
        label: "Width",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
    },
    {
        id: "Depth",
        label: "Depth",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
    },
    {
        id: "colours",
        label: "Colours",
        grouping: "Specifications",
        format: (value) => {
            if (value && value?.split !== undefined && colourMapKeys && colourArrayKeys) {
                let list = value.split(",");
                let output = [];
                for (let colour of list) {
                    if (colourMapKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else if (colourArrayKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else
                        output.push(
                            <span style={{ color: "orange" }}>
                                {(output.length === 0 ? "" : ",") + colour}{" "}
                                <WarningIcon
                                    style={{
                                        width: "17px",
                                        height: "13px",
                                        color: "#e29d35",
                                    }}
                                />
                            </span>
                        );
                }
                return output;
            }
            return "";
        },
        style: {
            width: "120px",
            minWidth: "120px",
        },
        autoComplete: colourArrayKeys,
    },
    {
        id: "Product Code",
        label: "Product Code",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Post Code",
        label: "Post Code",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Retainer Code",
        label: "Retainer Code",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
];

const slat_default = {
    Depth: "0",
    Name: "",
    "Post Code": "",
    "Product Code": "",
    "Retainer Code": "",
    Width: "0",
};

const infill_columns = (productlist_autocompleteOptions, colourMapKeys, colourArrayKeys) => [
    {
        id: "Key",
        label: "Key / Offering ID",
        style: {
            width: "100px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
        headerStyle: {
            width: "160px",
            minWidth: "160px",
            position: "sticky",
            left: "0",
            zIndex: "6",
            fontWeight: "600",
        },
    },
    {
        id: "name",
        label: "Display Name",
        style: {
            width: "100px",
        },
    },
    {
        id: "colours",
        label: "Colours",
        grouping: "Specifications",
        format: (value) => {
            if (value && value?.split !== undefined && colourMapKeys && colourArrayKeys) {
                let list = value.split(",");
                let output = [];
                for (let colour of list) {
                    if (colourMapKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else if (colourArrayKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else
                        output.push(
                            <span style={{ color: "orange" }}>
                                {(output.length === 0 ? "" : ",") + colour}{" "}
                                <WarningIcon
                                    style={{
                                        width: "17px",
                                        height: "13px",
                                        color: "#e29d35",
                                    }}
                                />
                            </span>
                        );
                }
                return output;
            }
            return "";
        },
        style: {
            width: "120px",
            minWidth: "120px",
        },
        autoComplete: colourArrayKeys,
    },
    {
        id: "allow_display_colour",
        label: "Allow Colour Selector",
        format: (val, row) => (val === true ? "Yes" : "No"),
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
    {
        id: "default_colour",
        label: "Default Colour",
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        autoComplete: colourMapKeys,
        hideInTable: true,
    },
    {
        id: "thumbnail",
        label: "Thumbnail",
        grouping: "Specifications",
        format: (value) => {
            if (value)
                return (
                    <img
                        style={{
                            maxHeight: "1.2rem",
                            width: "2.5rem",
                            objectFit: "contain",
                        }}
                        src={value}
                    />
                );
            return "";
        },
        style: {
            width: "80px",
        },
    },
    {
        id: "code",
        label: "Product Code",
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "type",
        label: "Type",
        style: {
            width: "80px",
        },
        format: (val, row) => (val === 1 ? "Vertical (per LM)" : "Rectangular Sheet"),
        grouping: "Specifications",
        select: [
            { Key: 1, Display: "Vertical (per LM)" },
            { Key: 3, Display: "Rectangular Sheet" },
        ],
    },
    {
        id: "coverage",
        label: "Coverage",
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        helperText:
            "for 'Vertical (per LM)' this is the sheet width.. for 'Rectangular Sheet' this is the mm2 coverage.",
    },
    {
        id: "allow_cyclonic",
        label: "Allow Cyclonic",
        format: (val, row) => (val === false ? "No" : "Yes"),
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
];

const infill_default = {
    name: "",
    colours: "",
    default_colour: "",
    allow_display_colour: true,
    texture: {
        filename: "qdrender.jpg",
        has_alpha: false,
        scale_mm: 20,
    },
    thumbnail: "",
    allow_cyclonic: true,
};

const downpipe_columns = (productlist_autocompleteOptions, colourMapKeys, colourArrayKeys) => [
    {
        id: "Key",
        label: "Key",
        style: {
            width: "160px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
        headerStyle: {
            width: "160px",
            minWidth: "160px",
            position: "sticky",
            left: "0",
            zIndex: "6",
            fontWeight: "600",
        },
    },
    {
        id: "Name",
        label: "Name (Offering ID)",
        style: {
            width: "160px",
        },
    },
    {
        id: "name",
        label: "Display Name",
        style: {
            width: "80px",
        },
        validate: "name",
    },
    {
        id: "thumbnail",
        label: "Thumbnail",
        grouping: "Specifications",
        format: (value) => {
            if (value)
                return (
                    <img
                        style={{
                            maxHeight: "1.2rem",
                            width: "2.5rem",
                            objectFit: "contain",
                        }}
                        src={value}
                    />
                );
            return "";
        },
        style: {
            width: "80px",
        },
    },
    {
        id: "Width",
        label: "Width",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
    },
    {
        id: "Depth",
        label: "Depth",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
    },
    {
        id: "default_colour",
        label: "Default Colour",
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        autoComplete: colourMapKeys,
        hideInTable: true,
    },
    {
        id: "colours",
        label: "Colours",
        grouping: "Specifications",
        format: (value) => {
            if (value && value?.split !== undefined && colourMapKeys && colourArrayKeys) {
                let list = value.split(",");
                let output = [];
                for (let colour of list) {
                    if (colourMapKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else if (colourArrayKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else
                        output.push(
                            <span style={{ color: "orange" }}>
                                {(output.length === 0 ? "" : ",") + colour}{" "}
                                <WarningIcon
                                    style={{
                                        width: "17px",
                                        height: "13px",
                                        color: "#e29d35",
                                    }}
                                />
                            </span>
                        );
                }
                return output;
            }
            return "";
        },
        style: {
            width: "120px",
            minWidth: "120px",
        },
        autoComplete: colourArrayKeys,
    },
    {
        id: "PVC",
        label: "Material",
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        format: (val, row) => (val == "1" ? "PVC" : "Steel"),
        select: [
            { Key: "0", Display: "Steel" },
            { Key: "1", Display: "PVC" },
        ],
    },
    {
        id: "Shape Index",
        label: "Shape",
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        format: (val, row) => (val == "1" ? "Round" : "Quad"),
        select: [
            { Key: "1", Display: "Round" },
            { Key: "2", Display: "Quad" },
        ],
    },
    {
        id: "Product Code",
        label: "Product Code",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Pop Code",
        label: "Pop Code",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Strap Code",
        label: "Strap Code",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Elbow",
        label: "Elbow Code",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Overhang Offset Code",
        label: "Overhang Offset Code",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Max Overhang Offset Span",
        label: "Max Overhang Offset Span (mm)",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        allCaps: true,
    },
];

const downpipe_default = {
    Depth: "0",
    Name: "NAME REQUIRED",
    "Pop Code": "",
    "Product Code": "",
    PVC: "0",
    "Shape Index": "1",
    "Strap Code": "",
    Width: "0",
};

const gutter_columns = (productlist_autocompleteOptions, colourMapKeys, colourArrayKeys) => [
    {
        id: "Key",
        label: "Key",
        style: {
            width: "160px",
            minWidth: "120px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
        headerStyle: {
            width: "160px",
            minWidth: "160px",
            position: "sticky",
            left: "0",
            zIndex: "6",
            fontWeight: "600",
        },
    },
    {
        id: "Name",
        label: "Name (Offering ID)",
        style: {
            width: "160px",
            minWidth: "120px",
        },
    },
    {
        id: "Display Name",
        label: "Display Name",
        alt_id: "Output Name",
        style: {
            width: "80px",
        },
        validate: "name",
    },
    {
        id: "thumbnail",
        label: "Thumbnail",
        grouping: "Specifications",
        format: (value) => {
            if (value)
                return (
                    <img
                        style={{
                            maxHeight: "1.2rem",
                            width: "2.5rem",
                            objectFit: "contain",
                        }}
                        src={value}
                    />
                );
            return "";
        },
        style: {
            width: "80px",
        },
    },
    {
        id: "Width",
        label: "Width",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
    },
    {
        id: "easy_fix_allowed",
        label: "Allow Easy Fix Mitres",
        grouping: "Specifications",
        format: (val, row) => (val === true ? "Yes" : "No"),
        style: {
            width: "80px",
        },
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
        hideInTable: true,
    },
    {
        id: "hand_made_mitres_allowed",
        label: "Hand Made Mitres",
        format: (val, row) => (val === true ? "Yes" : "No"),
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
        hideInTable: true,
    },
    {
        id: "default_colour",
        label: "Default Colour",
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        autoComplete: colourMapKeys,
        hideInTable: true,
    },
    {
        id: "colours",
        label: "Colours",
        grouping: "Specifications",
        format: (value) => {
            if (value && value?.split !== undefined && colourMapKeys && colourArrayKeys) {
                let list = value.split(",");
                let output = [];
                for (let colour of list) {
                    if (colourMapKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else if (colourArrayKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else
                        output.push(
                            <span style={{ color: "orange" }}>
                                {(output.length === 0 ? "" : ",") + colour}{" "}
                                <WarningIcon
                                    style={{
                                        width: "17px",
                                        height: "13px",
                                        color: "#e29d35",
                                    }}
                                />
                            </span>
                        );
                }
                return output;
            }
            return "";
        },
        style: {
            width: "120px",
            minWidth: "120px",
        },
        autoComplete: colourArrayKeys,
    },
    {
        id: "Product Code",
        label: "Product Code",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Easy Fix Mitre Code (External)",
        label: "Easy Fix Mitre Code (External 90° ONLY))",
        grouping: "Mitre Codes",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Easy Fix Mitre Code (Internal)",
        label: "Easy Fix Mitre Code (Internal 90° ONLY)",
        grouping: "Mitre Codes",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Mitre Code (External)",
        label: "Custom Mitre Code (External, not 90°)",
        grouping: "Mitre Codes",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Mitre Code (Internal)",
        label: "Custom Mitre Code (Internal, not 90°)",
        grouping: "Mitre Codes",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Stop End Left Code",
        label: "Stop End Left Code",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Stop End Right Code",
        label: "Stop End Right Code",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Strap Code",
        label: "Strap Code",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
];

const gutter_default = {
    "Box Gutter": "0",
    "Easy Fix Mitre Code (External)": "",
    "Easy Fix Mitre Code (Internal)": "",
    "Mitre Code (External)": "",
    "Mitre Code (Internal)": "",
    Name: "NAME REQUIRED",
    "Display Name": "",
    "Product Code": "",
    "Stop End Left Code": "",
    "Stop End Right Code": "",
    "Strap Code": "",
    Width: "",
};

const beam_gama_options = [
    "656510",
    "1086510",
    "1586510",
    "2086510",
    "50x50x1.6",
    "50x50x2.0",
    "50x50x2.5",
    "50x50x3.0",
    "50x50x4.0",
    "50x50x5.0",
    "60x60x1.6",
    "65x65x2.0",
    "65x65x2.5",
    "65x65x3.0",
    "75x75x2.0",
    "75x75x3.0",
    "90x90x2.0",
    "90x90x3.5",
    "90x90x5",
    "100x100x2.0",
    "100x100x3.0",
    "100x100x4.0",
    "100x50x1.6",
    "100x50x2.0",
    "100x50x2.5",
    "100x50x3.0",
    "100x50x4.0",
    "100x50x5.0",
    "125x125x4.0",
    "125x125x5.0",
    "150x50x2.0",
    "150x50x2.5",
    "150x50x3.0",
    "150x50x4.0",
    "150x50x5.0",
    "AL75x75x2",
    "AL90x90x2",
    "FL10011",
    "FL15015",
    "FL20020",
];

const sheet_gama_options = [
    "Ampelite Hr1 Polycarbonate Corrugated",
    "Ampelite Hr1 Polycarbonate Greca",
    "Ampelite SolaFrost Polycarbonate Corrugated",
    "Ampelite Solasafe Polycarbonate Corrugated",
    "Ampelite Solasafe Polycarbonate Greca",
    "Ampelite Solasafe Polycarbonate TL5",
    "Blue Orb .6bmt C/Bond",
    "Blue Orb .6bmt Zinc",
    "Cent 310 Deck",
    "Cent 310 Deck Alsynite",
    "Cent 310 Deck Polycarbonate",
    "Corrugated - C/Bond 0.42",
    "Corrugated - C/Bond D/S 0.42",
    "Corrugated - C/Bond 0.48",
    "Corrugated - Galv",
    "Corrugated - Zinc",
    "Hirib 0.42 G550 - C/Bond",
    "Hirib 0.42 G550 - C/Bond D/S",
    "Hirib 0.42 G550 - Zinc",
    "Hirib Alsynite Ultra 8oz",
    "Hirib Polycarbonate",
    "M-CLAD 0.42",
    "M-CLAD 0.42 D/S",
    "M-CLAD 0.48 (TL5)",
    "M-CLAD Polycarbonate 0.8mm",
    "TL5 0.42",
    "TL5 0.42 D/S",
    "TL5 0.48",
    "TL5 Polycarbonate 0.8mm",
    "SolarSpan 200",
    "SolarSpan 175",
    "SolarSpan 150",
    "SolarSpan 125",
    "SolarSpan 100",
    "SolarSpan 75",
    "SolarSpan 50",
    "Insulroof 200",
    "Insulroof 150",
    "Insulroof 125",
    "Insulroof 100",
    "Insulroof 50",
    "Insulroof 75",
    "Versiclad Versalink 1000 Smooth 100mm",
    "Versiclad Versalink 1000 Smooth 50mm",
    "Versiclad Versalink 1000 Smooth 75mm",
    "Versiclad Versalink 1000 Luxline 100mm",
    "Versiclad Versalink 1000 Luxline 50mm",
    "Versiclad Versalink 1000 Luxline 75mm",
    "Versiclad Corrolink-S Smooth 125mm",
    "Versiclad Corrolink-S Smooth 100mm",
    "Versiclad Corrolink-S Smooth 50mm",
    "Versiclad Corrolink-S Smooth 75mm",
    "Versiclad Corrolink-S Luxline 125mm",
    "Versiclad Corrolink-S Luxline 100mm",
    "Versiclad Corrolink-S Luxline 50mm",
    "Versiclad Corrolink-S Luxline 75mm",
    "FLATDEK",
    "FLATDEK II",
    "FLATDEK 310",
    "TRIMDEK",
    "SPANDEK 0.42",
    "SPANDEK 0.48",
    "KLIP-LOK 0.42",
    "Apollo Trimlink 50mm",
    "Apollo Trimlink 75mm",
    "Apollo Trimlink 100mm",
    "Apollo Trimlink 125mm",
    "Apollo Trimlink 150mm",
    "Apollo Trimlink 175mm",
    "Apollo Trimlink 200mm",
    "Apollo Corrugated 50mm",
    "Apollo Corrugated 75mm",
    "Apollo Corrugated 100mm",
    "Apollo Corrugated 125mm",
    "Apollo Corrugated 150mm",
];
const beam_colummns = (productlist_autocompleteOptions, colourMapKeys, colourArrayKeys) => [
    {
        id: "Key",
        label: "Key",
        style: {
            width: "160px",
            minWidth: "160px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
        headerStyle: {
            width: "160px",
            minWidth: "160px",
            position: "sticky",
            left: "0",
            zIndex: "6",
            fontWeight: "600",
        },
    },
    {
        id: "Name",
        label: "Name (Offering ID)",
        style: {
            width: "160px",
            minWidth: "160px",
        },
    },
    {
        id: "Display Name",
        alt_id: "Output Name",
        label: "Display Name",
        style: {
            width: "160px",
            minWidth: "120px",
        },
        validate: "name",
    },
    {
        id: "thumbnail",
        label: "Thumbnail",
        grouping: "Specifications",
        format: (value) => {
            if (value)
                return (
                    <img
                        style={{
                            maxHeight: "1.2rem",
                            width: "2.5rem",
                            objectFit: "contain",
                        }}
                        src={value}
                    />
                );
            return "";
        },
        style: {
            width: "80px",
        },
    },
    {
        id: "Height",
        label: "Height",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
    },
    {
        id: "Depth",
        label: "Depth",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
    },
    {
        id: "colours",
        label: "Colours",
        grouping: "Specifications",
        format: (value) => {
            if (value && value?.split !== undefined && colourMapKeys && colourArrayKeys) {
                let list = value.split(",");
                let output = [];
                for (let colour of list) {
                    if (colourMapKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else if (colourArrayKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else
                        output.push(
                            <span style={{ color: "orange" }}>
                                {(output.length === 0 ? "" : ",") + colour}{" "}
                                <WarningIcon
                                    style={{
                                        width: "17px",
                                        height: "13px",
                                        color: "#e29d35",
                                    }}
                                />
                            </span>
                        );
                }
                return output;
            }
            return "";
        },
        style: {
            width: "120px",
            minWidth: "120px",
        },
        autoComplete: colourArrayKeys,
    },
    {
        id: "Engineering ID",
        label: "Engineering ID",
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        validate: "name",
        select: beam_gama_options,
    },
    {
        id: "Product Code",
        label: "Product Code",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Beam_90Deg_Bracket_Code",
        label: "Beam_90Deg_Bracket_Code",
        grouping: "Beam To Beam Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Beam_Angle_Bracket_Code",
        label: "Beam_Angle_Bracket_Code",
        grouping: "Beam To Beam Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Beam_45Deg_Bracket_Code",
        label: "Beam_45Deg_Bracket_Code",
        grouping: "Beam To Beam Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Beam_to_Beam_Compound_Angle_Bracket_Code",
        label: "Beam_to_Beam_Compound_Angle_Bracket_Code",
        grouping: "Beam To Beam Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Beam_To_Beam_Joiner_Connector_Code",
        label: "Beam_To_Beam_Joiner_Connector_Code",
        grouping: "Beam End To End Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Beam_Joined_to_Beam_Angled_Bracket_Code",
        label: "Beam_Joined_to_Beam_Angled_Bracket_Code",
        grouping: "Beam End To End Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Internal_Bracket_Code",
        label: "Internal_Bracket_Code",
        grouping: "Beam End To End Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
        hideInTable: true,
    },
    {
        id: "Corner_Beam_to_Beam_Bracket_Code",
        label: "Corner_Beam_to_Beam_Bracket_Code",
        grouping: "Beam End To End Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Corner_Beam_with_100_Hip_Lower_Bracket_Code",
        label: "Corner_Beam_with_100_Hip_Lower_Bracket_Code",
        grouping: "Flat Hip Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Corner_Beam_with_150_Hip_Lower_Bracket_Code",
        label: "Corner_Beam_with_150_Hip_Lower_Bracket_Code",
        grouping: "Flat Hip Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "90_Deg_Corner_Beam_To_Post",
        label: "90_Deg_Corner_Beam_To_Post",
        grouping: "Flat Hip Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Beam_to_Fascia_Bracket_Code",
        label: "Beam_to_Fascia_Bracket_Code",
        grouping: "Attachment Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Rafter_to_Fascia_Bracket_Code",
        label: "Rafter_to_Fascia_Bracket_Code",
        grouping: "Attachment Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Rafter_to_Fascia_Non_Std_Bracket_Code",
        label: "Rafter_to_Fascia_Non_Std_Bracket_Code",
        grouping: "Attachment Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Beam_to_Wall_Bracket_Code",
        label: "Beam_to_Wall_Bracket_Code",
        grouping: "Attachment Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Flat_Hip_Beam_Top_to_Fascia_Corner_Bracket_Code",
        label: "Flat_Hip_Beam_Top_to_Fascia_Corner_Bracket_Code",
        grouping: "Attachment Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "DG_Hip_Rafter_Upper_Bracket_Code",
        label: "DG_Hip_Rafter_Upper_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Rafter_to_End_Beam_Bracket_Code",
        label: "Rafter_to_End_Beam_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Portal_Rafter_to_Post_Connector_Code",
        label: "Portal_Rafter_to_Post_Connector_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Sunken_Purlin_Rafter_to_End_Beam_Bracket_Code",
        label: "Sunken_Purlin_Rafter_to_End_Beam_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Portal_Rafter_to_Post_Sunken_Purlin_Connector_Code",
        label: "Portal_Rafter_to_Post_Sunken_Purlin_Connector_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Double_Hip_Rafter_Upper_Bracket_Code",
        label: "Double_Hip_Rafter_Upper_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Hip_Rafter_Upper_Bracket_Code",
        label: "Single_Hip_Rafter_Upper_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Hip_Rafter_Lower_Bracket_Code",
        label: "Hip_Rafter_Lower_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Hip_Rafter_Lower_Non_Std_Bracket_Code",
        label: "Hip_Rafter_Lower_Non_Std_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Jack_Rafter_Upper_Bracket_Code",
        label: "Jack_Rafter_Upper_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Jack_Rafter_Lower_Bracket_Code",
        label: "Jack_Rafter_Lower_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Hip Side Connector Lower Bracket Code",
        label: "Hip Side Connector Lower Bracket Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Sunken_Purlin_to_Rafter_Saddle_Bracket_Code",
        label: "Sunken_Purlin_to_Rafter_Saddle_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Portal_Hip_Beam_Connector_Code",
        label: "Portal_Hip_Beam_Connector_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Apex_Portal_Connector_Code",
        label: "Apex_Portal_Connector_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Apex_Connector_Code",
        label: "Apex_Connector_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Apex_with_Collar_Single_Connector_Code",
        label: "Apex_with_Collar_Single_Connector_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Apex_with_Collar_Double_Connector_Code",
        label: "Apex_with_Collar_Double_Connector_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Collar_Tie_to_Rafter_Bracket_Code",
        label: "Collar_Tie_to_Rafter_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Gable_End_Infill_Apex_Strut_Bracket_Code",
        label: "Gable_End_Infill_Apex_Strut_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Purlin_to_Hip_Rafter_Bracket_Code",
        label: "Purlin_to_Hip_Rafter_Bracket_Code",
        grouping: "Gable Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Eaves_Overhang_Connector_Code",
        label: "Eaves_Overhang_Connector_Code",
        grouping: "Other Codes",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Ceiling_Fan_to_Rafter_Bracket_Code",
        label: "Ceiling_Fan_to_Rafter_Bracket_Code",
        grouping: "Other Codes",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Ceiling_Fan_to_Downlight_Tray_Bracket_Code",
        label: "Ceiling_Fan_to_Downlight_Tray_Bracket_Code",
        grouping: "Other Codes",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Beam_End_Cap_Bracket_Code",
        label: "Beam_End_Cap_Bracket_Code",
        grouping: "Other Codes",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "End_Cap_Code",
        label: "End_Cap_Code",
        grouping: "Other Codes",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Curve_Rafter_to_Edge_Beam_Bracket_Code",
        label: "Curve_Rafter_to_Edge_Beam_Bracket_Code",
        grouping: "Curved Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Curve_Rafter_to_Infill_Beam_Bracket_Code",
        label: "Curve_Rafter_to_Infill_Beam_Bracket_Code",
        grouping: "Curved Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Gazebo_6_Sided_Connector_Code",
        label: "Gazebo_6_Sided_Connector_Code",
        grouping: "Gazebo Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Gazebo_8_Sided_Connector_Code",
        label: "Gazebo_8_Sided_Connector_Code",
        grouping: "Gazebo Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "BBQ_Main_End_Cap_Bracket_Code",
        label: "BBQ_Main_End_Cap_Bracket_Code",
        grouping: "BBQ Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "BBQ_Purlin_Connector_Bracket_Code",
        label: "BBQ_Purlin_Connector_Bracket_Code",
        grouping: "BBQ Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Cantilever_Insert_Code_Not_Used",
        label: "Cantilever_Insert_Code_Not_Used",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
        hideInTable: true,
    },
    {
        id: "Cantilever_End_Cap_Bracket_Code",
        label: "Cantilever_End_Cap_Bracket_Code",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
        hideInTable: true,
    },
    {
        id: "Joist_Connector_Code",
        label: "Joist_Connector_Code",
        grouping: "Deck Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Outside_Beam",
        label: "Outside Beam (RHS Sleeve)",
        style: {
            width: "80px",
        },
        validate: "name",
        allCaps: true,
    },
];

const beam_default = {
    Name: "REQUIRED",
    Depth: "0",
    Height: "0",
};

const post_columns = (productlist_autocompleteOptions, colourMapKeys, colourArrayKeys) => [
    {
        id: "Key",
        label: "Key",
        style: {
            width: "160px",
            minWidth: "120px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
        headerStyle: {
            width: "160px",
            minWidth: "160px",
            position: "sticky",
            left: "0",
            zIndex: "6",
            fontWeight: "600",
        },
    },
    {
        id: "Name",
        label: "Name (Offering ID)",
        style: {
            width: "160px",
            minWidth: "120px",
        },
    },
    {
        id: "Display Name",
        alt_id: "Output Name",
        label: "Display Name",
        style: {
            width: "160px",
            minWidth: "120px",
        },
        validate: "name",
    },
    {
        id: "thumbnail",
        label: "Thumbnail",
        grouping: "Specifications",
        format: (value) => {
            if (value)
                return (
                    <img
                        style={{
                            maxHeight: "1.2rem",
                            width: "2.5rem",
                            objectFit: "contain",
                        }}
                        src={value}
                    />
                );
            return "";
        },
        style: {
            width: "80px",
        },
    },
    {
        id: "Section Kind",
        label: "Section Kind",
        grouping: "Specifications",
        format: (val, row) => (val === 1 ? "RHS/SHS" : val === 2 ? "Box" : "Undefined"),
        style: {
            width: "80px",
        },
        select: [
            { Key: 1, Display: "RHS/SHS" },
            { Key: 2, Display: "Box" },
        ],
    },
    {
        id: "Width",
        label: "Width",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
    },
    {
        id: "Depth",
        label: "Depth",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
    },
    {
        id: "colours",
        label: "Colours",
        grouping: "Specifications",
        format: (value) => {
            if (value && value?.split !== undefined && colourMapKeys && colourArrayKeys) {
                let list = value.split(",");
                let output = [];
                for (let colour of list) {
                    if (colourMapKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else if (colourArrayKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else
                        output.push(
                            <span style={{ color: "orange" }}>
                                {(output.length === 0 ? "" : ",") + colour}{" "}
                                <WarningIcon
                                    style={{
                                        width: "17px",
                                        height: "13px",
                                        color: "#e29d35",
                                    }}
                                />
                            </span>
                        );
                }
                return output;
            }
            return "";
        },
        style: {
            width: "120px",
            minWidth: "120px",
        },
        autoComplete: colourArrayKeys,
    },
    {
        id: "allow_notched",
        label: "Allow Notched",
        grouping: "Specifications",
        format: (val, row) => (val === true ? "Yes" : "No"),
        style: {
            width: "80px",
        },
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
    {
        id: "allow_side",
        label: "Allow Side Attach",
        grouping: "Specifications",
        format: (val, row) => (val === true ? "Yes" : "No"),
        style: {
            width: "80px",
        },
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
    {
        id: "allow_behind",
        label: "Allow Behind",
        grouping: "Specifications",
        format: (val, row) => (val === true ? "Yes" : "No"),
        style: {
            width: "80px",
        },
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
    {
        id: "allow_under",
        label: "Allow Post Under",
        grouping: "Specifications",
        format: (val, row) => (val === false ? "No" : "Yes"),
        style: {
            width: "80px",
        },
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },

    {
        id: "allow_freestanding",
        label: "Allow In Freestanding",
        grouping: "Specifications",
        format: (val, row) => (val === false ? "No" : "Yes"),
        style: {
            width: "80px",
        },
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
        hideInTable: true,
    },
    {
        id: "max_length",
        label: "Max Height",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
    },
    {
        id: "Engineering ID",
        label: "Engineering ID",
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        validate: "name",
        select: beam_gama_options,
    },
    {
        id: "Product Code",
        label: "Product Code",
        grouping: "Product Code",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Product Code Notched",
        label: "Notched",
        grouping: "Product Code",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Product Code Flanged",
        label: "Flanged",
        grouping: "Product Code",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Product Code Flanged Notched",
        label: "Flanged Notched",
        grouping: "Product Code",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Base_Plate_Code_External",
        label: "Base_Plate_Code_External",
        grouping: "Base Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Base_Plate_Code_Flat_Internal",
        label: "Base_Plate_Code_Flat_Internal",
        grouping: "Base Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Base_Plate_Code_Gable_Internal",
        label: "Base_Plate_Code_Gable_Internal",
        grouping: "Base Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
        hideInTable: true,
    },
    {
        id: "Heavy_Footing_Bracket",
        label: "Heavy_Footing_Bracket",
        grouping: "Base Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Inground_Connector_Code",
        label: "Inground_Connector_Code",
        grouping: "Base Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "allow_flanged",
        label: "Allow Flanged Base",
        grouping: "Base Connectors",
        format: (val, row) => (val === false ? "No" : "Yes"),
        style: {
            width: "80px",
        },
        select: [
            { Key: false, Display: "No" },
            { Key: true, Display: "Yes" },
        ],
    },
    {
        id: "Cantilever_Insert_Code",
        label: "Cantilever_Insert_Code",
        grouping: "Top Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "External_Bracket_Code",
        label: "External_Bracket_Code",
        grouping: "Top Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Post_Top_Connection_Post_Behind_Bolt",
        label: "Post_Top_Connection_Post_Behind_Bolt",
        grouping: "Top Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "End Cap",
        label: "End Cap",
        grouping: "Top Connectors",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Shoe Code",
        label: "Shoe Code",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        allCaps: true,
    },
    {
        id: "Outside_Post",
        label: "Outside_Post",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        allCaps: true,
    },
];

const post_default = {
    Name: "REQUIRED",
    Depth: "0",
    Height: "0",
};

const sheet_columns = (productlist_autocompleteOptions, colourMapKeys, colourArrayKeys) => [
    {
        id: "Key",
        label: "Key",
        style: {
            width: "160px",
            minWidth: "120px",
            position: "sticky",
            left: "0",
            zIndex: "3",
            fontWeight: "600",
        },
        headerStyle: {
            width: "160px",
            minWidth: "160px",
            position: "sticky",
            left: "0",
            zIndex: "6",
            fontWeight: "600",
        },
    },
    {
        id: "Name",
        label: "Name (Offering ID)",
        style: {
            width: "160px",
            minWidth: "120px",
        },
    },
    {
        id: "Display Name",
        alt_id: "Output Name",
        label: "Display Name",
        style: {
            width: "160px",
            minWidth: "120px",
        },
        validate: "name",
    },
    {
        id: "Cover",
        label: "Cover",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
    },
    {
        id: "Sheet Width",
        label: "Sheet Width",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
        hideInTable: false,
    },
    {
        id: "Sheet Height",
        label: "Sheet Height",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
        hideInTable: false,
    },
    {
        id: "Min Length",
        label: "Min Length",
        grouping: "Specifications",
        style: {
            width: "80px",
        },
        validate: "numbersOnly",
    },
    {
        id: "Min Pitch",
        label: "Min Pitch",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numbersOnly",
    },
    {
        id: "Roof Profile Type",
        label: "Roof Profile Type",
        grouping: "Specifications",
        format: (val, row) => (val == "1" ? "Corrugated" : "Ribbed"),
        style: {
            width: "50px",
        },
        select: [
            { Key: "1", Display: "Corrugated" },
            { Key: "2", Display: "Ribbed" },
        ],
    },
    {
        id: "Spans",
        label: "Spans (Int/End/OH)",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        format: (val, row) => {
            let i = val?.MaxInternalSpan;
            let e = val?.MaxEndSpan;
            let o = val?.MaxOverhang;

            let Wzs = "";

            for (let key in val) {
                if (key.length < 3) {
                    Wzs += (Wzs === "" ? "" : ",") + key;
                }
            }
            return (
                <>
                    <div>
                        {i}/{e}/{o}
                    </div>
                    <div
                        style={{
                            fontSize: "8px",
                        }}
                    >
                        {Wzs}
                    </div>
                </>
            );
        },
        editor: (section, key, row, value, setValue, saveValue) => {
            return (
                <ManageMaterialsSpans
                    section={section}
                    ref_key={key}
                    row={row}
                    onClose={() => saveValue(null)}
                    saveValue={saveValue}
                />
            );
        },
        validate: "numbersOnly",
    },
    {
        id: "Mass",
        label: "Mass (kg/m2)",
        grouping: "Specifications",
        style: {
            width: "50px",
        },
        validate: "numeric",
    },
    {
        id: "Engineering ID",
        label: "Engineering ID",
        grouping: "Specifications",
        style: {
            width: "160px",
            minWidth: "120px",
        },
        validate: "name",
        selectStyle: { width: "600px", flex: "none" },
        select: sheet_gama_options,
    },
    {
        id: "Product Code",
        label: "Product Code",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
    },
    {
        id: "Back Channel",
        label: "Back Channel",
        grouping: "Back Channel",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
    },
    {
        id: "Back Channel Angle",
        label: "Back Channel Angle",
        grouping: "Back Channel",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
    },
    {
        id: "Barge Capping",
        label: "Standard",
        grouping: "Barge Capping",
        style: {
            width: "120px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
    },
    {
        id: "Barge Capping Overhang",
        label: "...with Overhang",
        grouping: "Barge Capping",
        style: {
            width: "120px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
    },
    {
        id: "Barge Capping Overhang With Purlin",
        label: "... Overhang with Purlin",
        grouping: "Barge Capping",
        style: {
            width: "120px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
    },
    {
        id: "Rear Barge Capping",
        label: "Rear Barge Capping (overrides barge capping)",
        grouping: "Barge Capping",
        style: {
            width: "120px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        helperText: "this setting overrrides barge code, such as for insulated panel... leave blank to use Barge Code.",
    },
    {
        id: "Rear Barge Capping Overhang",
        label: "Rear Barge Capping Overhang",
        grouping: "Barge Capping",
        style: {
            width: "120px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        helperText:
            "this setting overrrides barge code, such as for insulated panel... leave blank to use Rear Barge Capping.",
    },
    {
        id: "Front Overhang Flashing",
        label: "Front Overhang Flashing",
        grouping: "Barge Capping",
        style: {
            width: "120px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        helperText: "a front overhang flashing, such as insulated panel 'FOF'... Leave blank to not include one.",
    },
    {
        id: "Gable Front Overhang Flashing",
        label: "Gable Front Overhang Flashing",
        grouping: "Barge Capping",
        style: {
            width: "120px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
        helperText:
            "a GABLE front overhang flashing, such as insulated panel 'FOFG'... Leave blank to not include one.",
    },
    {
        id: "Cover Sheet Code",
        label: "Cover Sheet Code",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
    },
    {
        id: "Gutter Clip Code",
        label: "Gutter Clip Code",
        grouping: "Other Items",
        style: {
            width: "80px",
        },
        validate: "name",
        autoComplete: productlist_autocompleteOptions,
    },
    {
        id: "Use Return Gutter",
        label: "Use Return Gutter on Overhangs",
        grouping: "Other Items",
        format: (val, row) => (val === 1 ? "Yes" : "No"),
        style: {
            width: "80px",
        },
        select: [
            { Key: 0, Display: "No" },
            { Key: 1, Display: "Yes" },
        ],
    },
    {
        id: "colours",
        label: "Colours",
        grouping: "Offering Settings",
        format: (value) => {
            if (value && value?.split !== undefined && colourMapKeys && colourArrayKeys) {
                let list = value.split(",");
                let output = [];
                for (let colour of list) {
                    if (colourMapKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else if (colourArrayKeys.includes(colour.trim()))
                        output.push(<span>{(output.length === 0 ? "" : ",") + colour}</span>);
                    else
                        output.push(
                            <span style={{ color: "orange" }}>
                                {(output.length === 0 ? "" : ",") + colour}{" "}
                                <WarningIcon
                                    style={{
                                        width: "17px",
                                        height: "13px",
                                        color: "#e29d35",
                                    }}
                                />
                            </span>
                        );
                }
                return output;
            }
            return "";
        },
        style: {
            width: "120px",
            minWidth: "120px",
        },
        autoComplete: colourArrayKeys,
        hideInTable: true,
    },
    {
        id: "texture_filename",
        label: "Texture Filename",
        grouping: "Offering Settings",
        style: {
            width: "80px",
        },
        hideInTable: true,
    },
];

const sheet_default = {
    Name: "REQUIRED",
    Depth: "0",
    Height: "0",
    "Roof Profile Type": "1",
    "Use Return Gutter": 1,
};

const menu_columm = {
    id: "Menu",
    label: "Menu",
    editor: (section, key, row, value, setValue, saveValue, value2, setValue2, not_used, materials, setEditItem) => {
        let key_split = key.split("|");
        if (value === "DUPLICATE") {
            return (
                <>
                    <BSL_TextInput
                        label={"New Key"}
                        style={{ width: "150px", color: "white" }}
                        value={value2}
                        autoFocus
                        tight={true}
                        onEnter={(e) => {
                            if (!value2) {
                                alert("A Key is required to duplicate this item");
                                return;
                            }
                            if (materials?.[section]?.[value2]) {
                                alert("This key already exists");
                                return;
                            }
                            setValue("");
                            setValue2("");
                            saveValue(section, key, row, "ADD", e.target.value);
                        }}
                        onChange={(val) => {
                            setValue2(val);
                        }}
                        helperText={
                            materials?.[section]?.[value2] !== undefined
                                ? "This key is not valid or already exists"
                                : "Enter a new Key for this item"
                        }
                    />

                    <BSL_Button
                        style={{
                            margin: "28px 0px 5px",
                            padding: "5px 5px",
                            width: "100%",
                        }}
                        onClick={() => {
                            if (!value2) {
                                alert("A Key is required to duplicate this item");
                                return;
                            }
                            if (materials?.[section]?.[value2]) {
                                alert("This key already exists");
                                return;
                            }
                            setValue("");
                            setValue2("");
                            saveValue(section, value2, row, "ADD", value2);
                        }}
                    >
                        DUPLICATE
                    </BSL_Button>
                    <BSL_Button
                        secondary
                        style={{
                            margin: "0px 0px 5px",
                            padding: "5px 5px",
                            width: "100%",
                        }}
                        onClick={() => {
                            setValue("");
                        }}
                    >
                        CANCEL
                    </BSL_Button>
                </>
            );
        }
        if (value === "ADD VARIATION") {
            return (
                <>
                    <BSL_TextInput
                        label={"New Key"}
                        style={{ width: "150px", color: "white" }}
                        value={value2}
                        autoFocus
                        tight={true}
                        onEnter={(e) => {
                            if (!value2) {
                                alert("A Key is required to add a variation this item");
                                return;
                            }
                            if (materials?.[section]?.[value2]) {
                                alert("This key already exists");
                                return;
                            }
                            setValue("");
                            setValue2("");
                            saveValue(section, key + "|Variations", { Name: e.target.value }, "ADD", e.target.value);
                        }}
                        onChange={(val) => {
                            setValue2(val);
                        }}
                        helperText={
                            materials?.[section]?.[value2] !== undefined
                                ? "This key is not valid or already exists"
                                : "Enter a new Key for this item"
                        }
                    />
                    {/* key:  {key} */}
                    <BSL_Button
                        style={{
                            margin: "28px 0px 5px",
                            padding: "5px 5px",
                            width: "100%",
                        }}
                        onClick={() => {
                            if (!value2) {
                                alert("A Key is required to duplicate this item");
                                return;
                            }
                            if (materials?.[section]?.[value2]) {
                                alert("This key already exists");
                                return;
                            }
                            setValue("");
                            setValue2("");
                            saveValue(section, key + "|Variations", { Name: value2 }, "ADD", value2);
                        }}
                    >
                        ADD VARIATION
                    </BSL_Button>
                    <BSL_Button
                        secondary
                        style={{
                            margin: "0px 0px 5px",
                            padding: "5px 5px",
                            width: "100%",
                        }}
                        onClick={() => {
                            setValue("");
                        }}
                    >
                        CANCEL
                    </BSL_Button>
                </>
            );
        }

        return (
            <>
                <BSL_Button
                    style={{
                        margin: "28px 0px 5px",
                        padding: "5px 5px",
                        width: "100%",
                    }}
                    onClick={() => {
                        setValue2("");
                        setValue("DUPLICATE");
                    }}
                >
                    DUPLICATE
                </BSL_Button>
                {section !== "colour_map" && section !== "colour_arrays" && (
                    <>
                        <BSL_Button
                            style={{
                                margin: "0px 0px 5px",
                                padding: "5px 5px",
                                width: "100%",
                            }}
                            onClick={() => {
                                setValue2("");
                                setValue("ADD VARIATION");
                            }}
                            disabled={key_split.length > 3}
                        >
                            ADD VARIATION UNDER THIS ITEM
                        </BSL_Button>
                        <br />
                    </>
                )}
                <BSL_Button
                    style={{
                        margin: "0px 0px 5px",
                        width: "100%",
                        backgroundColor: "darkred",
                    }}
                    className={value === "DELETE" ? "deleteButtonConfirm" : "deleteButton"}
                    onClick={() => {
                        if (value === "DELETE") saveValue(section, key, row, "DELETE");
                        else setValue("DELETE");
                    }}
                >
                    <DeleteIcon />
                    {value === "DELETE" ? "CONFIRM?" : "DELETE"}
                </BSL_Button>
            </>
        );
    },
};

export default function ManageMaterials(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const theme = useTheme();

    // const {
    //     materials,
    //     setMaterials,
    //     pricefile,
    //     setPricefile,
    //     pricefileDescSummary,
    //     setPricefileDescSummary,
    //     cds_docs,
    //     setCDSOffering,
    //     lld_docs,
    //     setLLDOffering,
    // } = props;

    const [tab, setTab] = React.useState(0);

    const [intialise, setIntialise] = React.useState(false);
    // const [materials, setMaterials] = React.useState(null);
    // const [pricefile, setPricefile] = React.useState(null);
    // const [pricefileDescSummary, setPricefileDescSummary] = React.useState(null);

    const [materials, setMaterials] = React.useState(null);
    const [pricefile, setPricefile] = React.useState(null);
    const [pricefileDescSummary, setPricefileDescSummary] = React.useState(null);
    const [cds_docs, setCDSOffering] = React.useState(null);
    const [lld_docs, setLLDOffering] = React.useState(null);
    const [materialsKeys, setMaterialsKeys] = React.useState(null);

    const [autocompleteOptions, setAutocompleteOptions] = React.useState(null);
    const [thumbs, setThumbs] = React.useState({});
    const [colourArrayKeys, setColourArrayKeys] = React.useState([]);
    const [colourMapKeys, setColourMapKeys] = React.useState([]);

    const [editCell, setEditCell] = React.useState(null);
    const [editItem, setEditItem] = React.useState(false);
    const [value, setValue] = React.useState("");
    const [value2, setValue2] = React.useState("");
    const [saving, setSaving] = React.useState({}); // not fast enough! hackign with a global var
    if (window.saving === undefined) window.saving = {};

    const [slatRows, setSlatRows] = React.useState([]);
    const [infillRows, setInfillRows] = React.useState([]);
    const [downpipeRows, setDownpipeRows] = React.useState([]);
    const [gutterRows, setGutterRows] = React.useState([]);
    const [beamRows, setBeamRows] = React.useState([]);
    const [postRows, setPostRows] = React.useState([]);
    const [sheetRows, setSheetRows] = React.useState([]);
    const [colourRows, setColourRows] = React.useState([]);
    const [colourArrayRows, setColourArrayRows] = React.useState([]);
    const [defaultCADSettingsRows, setDefaultCADSettingsRows] = React.useState([]);

    const [showVariations, setShowVariations] = React.useState({});

    const toggleShowVariation = (key) => {
        let new_showVariations = { ...showVariations };
        if (new_showVariations[key] !== undefined) delete new_showVariations[key];
        else new_showVariations[key] = true;
        setShowVariations(new_showVariations);
    };

    React.useEffect(() => {
        if (pricefile) {
            let summary = {};
            let options = [];
            let thumbs = {};
            for (let item of pricefile["data"]) {
                summary[item.ProductIndex] = item.ProductDescription;
                options.push(item.ProductIndex + " - " + item.ProductDescription);
                if (item.Image_b64) thumbs[item.ProductIndex] = item.Image_b64;
            }
            setPricefileDescSummary(summary);
            setAutocompleteOptions(options);
            setThumbs(thumbs);
        }
    }, [pricefile]);

    React.useEffect(() => {
        if (materials) {
            if (!window?.config) window.config = {};
            window.config.colour_map = { ...materials?.colour_map };
            setColourArrayKeys(Object.keys(materials?.colour_arrays));
            setColourMapKeys(Object.keys(materials?.colour_map));
        }
    }, [materials]);

    React.useEffect(() => {
        if (!intialise) {
            let api_url = API_BASE() + "admin/GetOfferingFile?name=MATERIALS";
            fetchTimeout(
                api_url,
                {
                    method: "GET",
                },
                90000
            )
                .then((response) => response.json())
                .then((json) => {
                    setValue("");
                    setValue2("");
                    setEditCell(null);

                    setMaterials(json?.MATERIALS);
                    setPricefile(json?.PRICE_FILE);
                    setIntialise(true);
                })
                .catch((e) => {
                    setMaterials(null);
                });
        }
    }, [intialise]);

    let row_i = 0;
    let row_i_base = 0;

    const createRows = (
        section,
        data,
        columns,
        default_item = {},
        add_new_row = true,
        parent,
        grandparent,
        greatgrandparent,
        greatgreatgrandparent,
        parent_background,
        parent_key
    ) => {
        let table_rows = [];

        let keys = null;
        if (data) keys = Object.keys(data).sort();

        if (keys)
            keys.map((key, index) => {
                let row = data[key];
                if (row?.hideInTable) return null;

                let full_path_key = parent_key ? parent_key + "|" + key : key;
                row_i++;
                if (!parent) row_i_base++;

                let row_background = row_i_base % 2 === 0 ? "#e7ebee" : "#ffffff";
                if (parent) row_background = row_i % 2 === 0 ? "#f8f4df" : "#fffef8";

                let visible = true;
                if (parent) {
                    visible = false;
                    if (showVariations[parent_key.split("|")[0]] !== undefined) visible = true;
                }

                table_rows.push(
                    <TableRow
                        key={key}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        className={classes.row}
                        style={{
                            background: row_background,
                            display: visible ? "table-row" : "none",
                        }}
                    >
                        {columns.map((column) => {
                            if (column?.hideInTable) return null;

                            let value = "";
                            if (column.id === "ARRAY_DATA") {
                                value = row;
                            } else {
                                value = row?.[column.id];
                                if (value === undefined) value = row?.[column.id.replaceAll("_", " ")];
                                if (value === undefined) value = row?.[column.id.replaceAll(" ", "_")];
                                if (value === undefined && column.alt_id) {
                                    value = row?.[column.alt_id];
                                    if (value === undefined) {
                                        value = row?.[column.alt_id.replaceAll("_", " ")];
                                    }
                                    if (value === undefined) {
                                        value = row?.[column.alt_id.replaceAll(" ", "_")];
                                    }
                                }
                            }

                            let display_value = value;

                            let inherited = false;
                            let padding_left = null;
                            let background = row_background;

                            let warning = false;
                            let thumb = null;
                            if (column.autoComplete && value) {
                                let value_to_check = value.replaceAll("<R1>", "").replaceAll("<DS>", "").split("^")[0];
                                let value2_to_check = value.includes("^")
                                    ? value.replaceAll("<R1>", "").replaceAll("<DS>", "").split("^")[1]
                                    : null;

                                if (column?.format === undefined) {
                                    let found = false;
                                    let autoComplete_list = null;

                                    if (
                                        typeof column.autoComplete === "object" &&
                                        !Array.isArray(column.autoComplete)
                                    ) {
                                        autoComplete_list = Object.keys(column.autoComplete);
                                    } else autoComplete_list = column.autoComplete;

                                    if (autoComplete_list && Array.isArray(autoComplete_list))
                                        for (let item of autoComplete_list) {
                                            if (item === value_to_check) found = true;
                                            if (item.split("-")[0].trim() === value_to_check) found = true;
                                            if (value2_to_check) {
                                                if (item === value2_to_check) found = true;
                                                if (item.split("-")[0].trim() === value2_to_check) found = true;
                                            }
                                            if (found) break;
                                        }
                                    if (!found) warning = true;

                                    if (value.includes("<R1>")) warning = false;
                                    if (value === " ") warning = false;
                                }

                                if (thumbs[value_to_check]) thumb = thumbs[value_to_check];
                                if (!thumb && value2_to_check && thumbs[value2_to_check])
                                    thumb = thumbs[value2_to_check];
                            }

                            if (column.id === "Key") {
                                value = key;
                                display_value = value;
                                if (parent) {
                                    padding_left = "50px";
                                    display_value = "➥" + key;
                                    background =
                                        "linear-gradient(90deg," +
                                        parent_background +
                                        " 34px" +
                                        ",#acacac 40px, blanchedalmond 20px)";
                                    if (grandparent)
                                        background =
                                            "linear-gradient(90deg," +
                                            parent_background +
                                            " 34px" +
                                            ",#acacac 40px, blanchedalmond 20px, #f0dbba 65px)";
                                    if (greatgrandparent)
                                        background =
                                            "linear-gradient(90deg," +
                                            parent_background +
                                            " 34px" +
                                            ",#acacac 40px, blanchedalmond 20px, #f0dbba 65px, #e1c8a0 85px)";
                                }
                                if (grandparent) {
                                    padding_left = "60px";
                                    display_value = "➥" + key;
                                }
                                if (greatgrandparent) {
                                    padding_left = "70px";
                                    display_value = "➥➥" + key;
                                }
                                if (greatgreatgrandparent) {
                                    padding_left = "80px";
                                    display_value = "➥➥➥" + key;
                                }
                            } else if (value === undefined && column.id === "Name") {
                                display_value = key;
                                inherited = true;
                            } else if (value === undefined && parent?.[column.id] != undefined) {
                                display_value = parent[column.id];
                                inherited = true;
                            } else if (value === undefined && grandparent?.[column.id] != undefined) {
                                display_value = grandparent[column.id];
                                inherited = true;
                            } else if (value === undefined && greatgrandparent?.[column.id] != undefined) {
                                display_value = greatgrandparent[column.id];
                                inherited = true;
                            } else if (value === undefined && greatgreatgrandparent?.[column.id] != undefined) {
                                display_value = greatgreatgrandparent[column.id];
                                inherited = true;
                            }

                            if (inherited) {
                                background = "blanchedalmond";
                                if (greatgrandparent) background = "#f2ddbd";
                            }

                            if (column.select) {
                                let value_to_check = value;
                                if (inherited) value_to_check = display_value;
                                let found = false;
                                for (var item of column.select) {
                                    if (typeof item === "string") {
                                        if (value_to_check === item) found = true;
                                        if (item === "0" && item == value_to_check) found = true;
                                        if (toNumber(item) > 0 && toNumber(item) == value_to_check) found = true;
                                    }
                                    if (typeof item === "object") {
                                        if (item?.Key === value_to_check) found = true;
                                        if (item?.Key === false && !value_to_check) found = true;
                                        if (item?.Key === true && value_to_check === true) found = true;
                                        if (item?.Key === "0" && item?.Key == value_to_check) found = true;
                                        if (toNumber(item?.Key) > 0 && toNumber(item?.Key) == value_to_check)
                                            found = true;
                                    }
                                    if (found) break;
                                }
                                if (!found) warning = true;
                                if (value_to_check === " ") warning = false;
                            }

                            return (
                                <TableCell
                                    key={section + key + "-" + column.id}
                                    align={column.align}
                                    className={classes.rowCell}
                                    style={
                                        column.style
                                            ? {
                                                  ...column.style,
                                                  color: inherited ? "#ae9292" : "inherit",
                                                  fontStyle: inherited ? "italic" : "none",
                                                  paddingLeft: padding_left,
                                                  background: background,
                                                  fontSize: greatgrandparent ? "10px" : null,
                                              }
                                            : {
                                                  color: inherited ? "#ae9292" : "inherit",
                                                  fontStyle: inherited ? "italic" : "none",
                                                  paddingLeft: padding_left,
                                                  background: background,
                                                  fontSize: greatgrandparent ? "10px" : null,
                                              }
                                    }
                                    onClick={(e) => {
                                        if (editCell || editCell?.noEdit) {
                                            setValue("");
                                            setValue2("");
                                            setEditCell(null);
                                        } else {
                                            setValue(value);
                                            setValue2("");
                                            setEditCell({
                                                anchorEl: e.currentTarget,
                                                section: section,
                                                key: full_path_key,
                                                row: row,
                                                column: { ...column },
                                            });
                                        }
                                        e.stopPropagation();
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                        }}
                                    >
                                        {inherited && (
                                            <div
                                                style={{
                                                    color: "#f59758",
                                                    marginTop: "-4px",
                                                    fontSize: "8px",
                                                    // position: "absolute",
                                                    float: "left",
                                                    whiteSpace: "nowrap",
                                                    height: "10px",
                                                }}
                                            >
                                                {column.id === "Name" ? "→ inherited →" : "↓ inherited ↓"}
                                            </div>
                                        )}
                                        <div style={{ flex: 1, whiteSpace: warning || thumb ? "nowrap" : "normal" }}>
                                            {thumb && (
                                                <img
                                                    style={{
                                                        maxHeight: "1.2rem",
                                                        width: "2.5rem",
                                                        objectFit: "contain",
                                                    }}
                                                    src={thumb}
                                                />
                                            )}
                                            {column.format ? column.format(display_value, row) : display_value}
                                            {warning && (
                                                <WarningIcon
                                                    style={{
                                                        width: "17px",
                                                        height: "13px",
                                                        color: "#e29d35",
                                                    }}
                                                />
                                            )}
                                            {window.saving &&
                                                window.saving?.[section + "_" + full_path_key] &&
                                                column?.id === window.saving?.[section + "_" + full_path_key] && (
                                                    <LinearProgress />
                                                )}
                                            {window.saving &&
                                                window.saving?.[section + "_" + full_path_key] &&
                                                "Error:" + column?.id ===
                                                    window.saving?.[section + "_" + full_path_key] && (
                                                    <ErrorIcon style={{ color: "red" }} />
                                                )}
                                        </div>
                                    </div>
                                </TableCell>
                            );
                        })}

                        <TableCell
                            key={section + key + "-Menu"}
                            className={classes.rowCell}
                            onClick={(e) => {
                                if (editCell || menu_columm?.editor === undefined) {
                                    setValue("");
                                    setValue2("");
                                    setEditCell(null);
                                } else {
                                    setValue(value);
                                    setEditCell({
                                        anchorEl: e.currentTarget,
                                        section: section,
                                        key: full_path_key,
                                        row: row,
                                        column: { ...menu_columm },
                                    });
                                }
                                e.stopPropagation();
                            }}
                        >
                            <IconButton className={classes.moreButton}>
                                <MoreVertIcon />
                            </IconButton>
                            {window.saving &&
                                window.saving?.[section + "_" + full_path_key] &&
                                ["DELETE", "ADD"].includes(window.saving?.[section + "_" + full_path_key]) && (
                                    <LinearProgress />
                                )}
                            {window.saving &&
                                window.saving?.[section + "_" + full_path_key] &&
                                ["Error:DELETE"].includes(window.saving?.[section + "_" + full_path_key]) && (
                                    <ErrorIcon style={{ color: "red" }} />
                                )}
                        </TableCell>
                    </TableRow>
                );

                if (row.Variations && Object.keys(row.Variations).length > 0) {
                    if (!parent)
                        table_rows.push(
                            <TableRow
                                key={section + index + key}
                                hover
                                role="checkbox"
                                tabIndex={-1}
                                className={classes.row}
                                style={{
                                    padding: "2px 2px 2px 30px",
                                    fontSize: "smaller",
                                    background: row_background,
                                }}
                            >
                                <TableCell
                                    style={{
                                        padding: "0px",
                                        fontSize: "smaller",
                                        borderBottom: "None",
                                        position: "sticky",
                                        left: "0",
                                        zIndex: "3",
                                    }}
                                    onClick={() => {
                                        toggleShowVariation(key);
                                    }}
                                >
                                    <div
                                        className="link"
                                        style={{
                                            padding: "2px 20px 2px 10px",
                                            fontSize: "smaller",
                                            background: "blanchedalmond",
                                            marginLeft: "40px",
                                            height: "100%",
                                            borderTop: "solid 2px #acacac",
                                            boxShadow: "-2px 0px 6px 0px rgb(0 0 0 / 75%)",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {/* import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'; */}
                                        <IconButton
                                            aria-label="delete"
                                            size="small"
                                            onClick={() => {
                                                toggleShowVariation(key);
                                            }}
                                            style={{
                                                height: "14px",
                                                width: "17px",
                                                padding: "0px",
                                            }}
                                        >
                                            {showVariations[key] ? (
                                                <RemoveIcon
                                                    style={{
                                                        height: "12px",
                                                        width: "12px",
                                                    }}
                                                />
                                            ) : (
                                                <AddIcon
                                                    style={{
                                                        height: "12px",
                                                        width: "12px",
                                                    }}
                                                />
                                            )}
                                        </IconButton>{" "}
                                        VARIATIONS ({Object.keys(row.Variations).length})
                                    </div>
                                </TableCell>
                                <TableCell
                                    colSpan={columns.length}
                                    style={{
                                        padding: "2px 2px 2px 30px",
                                        fontSize: "smaller",
                                        background: "blanchedalmond",
                                        borderTop: "solid 2px #acacac",
                                        boxShadow: "rgb(0 0 0 / 50%) 2px -2px 2px 0px",
                                        position: "sticky",
                                        left: "0",
                                        zIndex: "2",
                                    }}
                                ></TableCell>
                            </TableRow>
                        );

                    table_rows.push(
                        createRows(
                            section,
                            row.Variations,
                            columns,
                            default_item,
                            false,
                            row,
                            parent,
                            grandparent,
                            greatgrandparent,
                            parent_background ? parent_background : row_background,
                            full_path_key
                        )
                    );
                }
            });

        if (add_new_row) {
            row_i++;
            table_rows.push(
                <TableRow
                    key={section + "_new_row"}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    className={classes.row}
                    style={{ background: row_i % 2 === 0 ? "#e7ebee" : "#ffffff" }}
                >
                    {columns.map((column) => {
                        let value = "";
                        return (
                            <TableCell
                                key={"slat_new_row-" + column.id}
                                align={column.align}
                                className={classes.rowCell}
                                style={column.style ? column.style : {}}
                                onClick={(e) => {
                                    if (editCell || menu_columm?.editor === undefined) {
                                        setValue("");
                                        setValue2("");
                                        setEditCell(null);
                                    } else {
                                        setValue(value);
                                        setEditCell({
                                            anchorEl: e.currentTarget,
                                            section: section,
                                            key: "Key",
                                            row: default_item,
                                            column: {
                                                id: "ADD",
                                                label: "New Key",
                                                style: {
                                                    width: "50px",
                                                },
                                            },
                                        });
                                    }
                                    e.stopPropagation();
                                }}
                            >
                                {window.saving &&
                                    window.saving?.[section + "_Key"] &&
                                    "ADD" === window.saving?.[section + "_Key"] && <LinearProgress />}
                                {window.saving &&
                                    window.saving?.[section + "_Key"] &&
                                    "Error:" + "ADD" === window.saving?.[section + "_Key"] && (
                                        <ErrorIcon style={{ color: "red" }} />
                                    )}
                                {column.id === "Key" && <span className="link">+ Add New Row</span>}
                            </TableCell>
                        );
                    })}
                </TableRow>
            );
        }
        return table_rows;
    };

    const getGroupHeaders = (columns) => {
        let grouping_headers = [];

        let last_grouping = undefined;
        let num_in_this_group = -1;
        let header_i = 0;
        for (let column of columns()) {
            if (column?.hideInTable) continue;
            let this_grouping = column?.grouping;
            if (
                this_grouping !== last_grouping ||
                (this_grouping === undefined && last_grouping) ||
                num_in_this_group > 8
            ) {
                //change in grouping. print cell

                let cell_style = {};
                if (header_i % 2 === 0) cell_style.background = "#936a2b !important";

                grouping_headers.push(
                    <TableCell
                        key={column.id}
                        className={
                            (last_grouping ? classes.categoryHeadingCell : classes.categoryHeadingCellBlank) +
                            " " +
                            classes.headingCell
                        }
                        style={cell_style}
                        colSpan={num_in_this_group + 1}
                    >
                        {last_grouping ? last_grouping : ""}
                    </TableCell>
                );
                header_i++;
                last_grouping = this_grouping;
                num_in_this_group = 0;
            } else {
                num_in_this_group++;
            }
        }

        if (num_in_this_group > 0) {
            let cell_style = {};
            if (header_i % 2 === 0) cell_style.background = "#936a2b !important";

            grouping_headers.push(
                <TableCell
                    key={"beam_col_end"}
                    className={
                        (last_grouping ? classes.categoryHeadingCell : classes.categoryHeadingCellBlank) +
                        " " +
                        classes.headingCell
                    }
                    colSpan={num_in_this_group + 1}
                >
                    {last_grouping ? last_grouping : ""}
                </TableCell>
            );
        }
        return grouping_headers;
    };

    React.useEffect(() => {
        if (!materials) return;

        setDefaultCADSettingsRows(
            createRows(
                "default_cad_settings",
                materials?.default_cad_settings
                    ? materials.default_cad_settings
                    : {
                          BARGE_CAPPING_EXTRA: {
                              Value: 165,
                              SystemDefault: 165,
                          },
                          BEAM_CUT_EXTRA: {
                              Value: 30,
                              SystemDefault: 30,
                          },
                          BOX_GUTTER_WIDTH_EXTRA: {
                              Value: 150,
                              SystemDefault: 150,
                          },
                          BOX_GUTTER_WIDTH_EXTRA: {
                              Value: 150,
                              SystemDefault: 150,
                          },
                          COLLAR_TIE_RATIO: {
                              Value: 0.3,
                              SystemDefault: 0.3,
                          },
                          DOWNLIGHT_FLASHING_EXTRA: {
                              Value: 250,
                              SystemDefault: 250,
                          },
                          DOWNPIPE_LOW_HEIGHT: {
                              Value: 100,
                              SystemDefault: 100,
                          },
                          DOWNPIPE_OFFSET_TOLERANCE: {
                              Value: 175,
                              SystemDefault: 175,
                          },
                          DOWNPIPE_REQ_AREA: {
                              Value: 50,
                              SystemDefault: 50,
                          },
                          DOUBLE_RISER_BRACKET_WIDTH: {
                              Value: 210,
                              SystemDefault: 210,
                          },
                          FLASHING_CUT_EXTRA: {
                              Value: 200,
                              SystemDefault: 200,
                          },
                          FREESPAN_BEAM_CUT_EXTRA: {
                              Value: 30,
                              SystemDefault: 30,
                          },
                          FREESPAN_DEPTH: {
                              Value: 109,
                              SystemDefault: 109,
                          },
                          PORTAL_GABLE_GAZEBO_PURLIN_CUT_EXTRA: {
                              QQKey: "GABLE_HIP_ROOF_GAZEBO_PURLIN_CUT_EXTRA",
                              Value: 50,
                              SystemDefault: 50,
                          },
                          PORTAL_GABLE_TOP_PURLIN_OFFSET: {
                              QQKey: "GABLE_HIP_TOP_PURLIN_OFFSET",
                              Value: 45,
                              SystemDefault: 45,
                          },
                          PORTAL_GABLE_TOP_PURLIN_OFFSET2: {
                              QQKey: "GABLE_HIP_TOP_PURLIN_OFFSET2",
                              Value: 45,
                              SystemDefault: 45,
                          },
                          PORTAL_GABLE_SQUARE_BARGE_RETURN: {
                              QQKey: "SQUARE_BARGE_RETURN",
                              Value: 20,
                              SystemDefault: 20,
                              hideInTable: true,
                          },
                          PORTAL_GABLE_FREESPAN_HEIGHT_DIFFERENCE: {
                              QQKey: "FREESPAN_HEIGHT_DIFFERENCE",
                              Value: 97,
                              SystemDefault: 97,
                              hideInTable: true,
                          },
                          GUTTER_END_EXTRA: {
                              QQKey: "GUTTER_END_EXTRA",
                              Value: 200,
                              SystemDefault: 200,
                          },
                          GUTTER_LAP_EXTRA: {
                              QQKey: "GUTTER_LAP_EXTRA",
                              Value: 100,
                              SystemDefault: 100,
                          },
                          GUTTER_MAX_LENGTH: {
                              QQKey: "GUTTER_MAX_LENGTH",
                              Value: 8000,
                              SystemDefault: 8000,
                          },
                          GUTTER_MITRE_EXTRA: {
                              QQKey: "GUTTER_MITRE_EXTRA",
                              Value: 200,
                              SystemDefault: 200,
                          },
                          HIP_CAPPING_EXTRA: {
                              QQKey: "HIP_CAPPING_EXTRA",
                              Value: 300,
                              SystemDefault: 300,
                          },
                          HIP_JUNCTION_HIP_END_EXTENSION: {
                              QQKey: "HIP_JUNCTION_HIP_END_EXTENSION",
                              Value: 150,
                              SystemDefault: 150,
                          },
                          INFILL_BEAM_EXTRA: {
                              QQKey: "INFILL_BEAM_EXTRA",
                              Value: 100,
                              SystemDefault: 100,
                          },
                          INFILL_FLASHING_EXTRA: {
                              QQKey: "INFILL_FLASHING_EXTRA",
                              Value: 250,
                              SystemDefault: 250,
                          },
                          INFILL_TRIM_FLASHING_EXTRA: {
                              QQKey: "INFILL_TRIM_FLASHING_EXTRA",
                              Value: 350,
                              SystemDefault: 350,
                          },
                          MAX_FLASHING_LENGTH: {
                              QQKey: "MAX_FLASHING_LENGTH",
                              Value: 6100,
                              SystemDefault: 6100,
                          },
                          MAX_SLAT_PANEL_LENGTH: {
                              QQKey: "MAX_SLAT_PANEL_LENGTH",
                              Value: 4000,
                              SystemDefault: 4000,
                          },
                          MAX_SLAT_PANEL_LENGTH: {
                              QQKey: "MAX_SLAT_PANEL_LENGTH",
                              Value: 4000,
                              SystemDefault: 4000,
                          },
                          MAX_SOLARSPAN_FLASHING_LENGTH: {
                              QQKey: "MAX_SOLARSPAN_FLASHING_LENGTH",
                              Value: 7500,
                              SystemDefault: 7500,
                          },
                          MIN_POST_HEIGHT: {
                              QQKey: "MIN_POST_HEIGHT",
                              Value: 2000,
                              SystemDefault: 2000,
                          },
                          PORTAL_INFILL_STRUT_EXTRA: {
                              QQKey: "PORTAL_STRUT_EXTRA",
                              Value: 200,
                              SystemDefault: 200,
                          },
                          POST_EXTRA: {
                              QQKey: "POST_EXTRA",
                              Value: 100,
                              SystemDefault: 100,
                          },
                          RAFTER_BRACKET_OFFSET: {
                              QQKey: "RAFTER_BRACKET_OFFSET",
                              Value: 100,
                              SystemDefault: 100,
                          },
                          SHEET_INTO_GUTTER: {
                              QQKey: "SHEET_INTO_GUTTER",
                              Value: 60,
                              SystemDefault: 60,
                          },
                          SHEET_INTO_GUTTER_SOLARSPAN: {
                              QQKey: "SHEET_INTO_GUTTER_SOLARSPAN",
                              Value: 60,
                              SystemDefault: 60,
                          },
                          MAX_INFILL_SHEET_PANEL_LENGTH: {
                              QQKey: "MAX_SHEET_PANEL_LENGTH",
                              Value: 4000,
                              SystemDefault: 4000,
                          },
                          SHEET_PANEL_FLASHING_DEPTH: {
                              QQKey: "SHEET_PANEL_FLASHING_DEPTH",
                              Value: 38,
                              SystemDefault: 38,
                          },
                          SHEET_RIDGE_OFFSET: {
                              QQKey: "SHEET_RIDGE_OFFSET",
                              Value: 10,
                              SystemDefault: 10,
                          },
                          SHEET_TAPER_EXTRA: {
                              QQKey: "SHEET_TAPER_EXTRA",
                              Value: 200,
                              SystemDefault: 200,
                          },
                          POST_SET_INTO_FOOTING_DISTANCE: {
                              QQKey: "SET_INTO_FOOTING_DISTANCE",
                              Value: 500,
                              SystemDefault: 500,
                          },
                          SET_INTO_FOOTING_DISTANCE_CANTILEVER: {
                              QQKey: "SET_INTO_FOOTING_DISTANCE_CANTILEVER",
                              Value: 300,
                              SystemDefault: 300,
                              hideInTable: true,
                          },
                          SKILLION_ROOF_SHEET_EXT: {
                              QQKey: "SKILLION_ROOF_SHEET_EXT",
                              Value: 50,
                              SystemDefault: 50,
                          },
                          WALL_PORTAL_OFFSET: {
                              QQKey: "WALL_PORTAL_OFFSET",
                              Value: 50,
                              SystemDefault: 50,
                          },
                          FREESTANDING_SLAT_POST: {
                              QQKey: "FREESTANDING_SLAT_POST",
                              Value: "50mm x 50mm x 3mm P/C",
                              SystemDefault: "50mm x 50mm x 3mm P/C",
                          },
                          PORTAL_GAZEBO_POST: {
                              QQKey: "GABLE_HIP_GAZEBO_POST",
                              Value: "656510",
                              SystemDefault: "656510",
                          },
                          PORTAL_ON_TOP_BEAM: {
                              QQKey: "GABLE_HIP_ON_TOP_BEAM",
                              Value: "656510",
                              SystemDefault: "656510",
                          },
                          PORTAL_ON_TOP_PURLIN: {
                              QQKey: "GABLE_HIP_ON_TOP_PURLIN",
                              Value: "656510",
                              SystemDefault: "656510",
                          },
                          GUTTER_BEAM: {
                              QQKey: "GUTTER_BEAM",
                              Value: "1586510",
                              SystemDefault: "1586510",
                          },
                          ON_TOP_BEAM: {
                              QQKey: "ON_TOP_BEAM",
                              Value: "656510",
                              SystemDefault: "656510",
                          },
                          PORTAL_STRUT_BEAM: {
                              QQKey: "STRUT_BEAM",
                              Value: "656510",
                              SystemDefault: "656510",
                          },
                      },
                default_cad_settings_columns(),
                {
                    Value: "",
                    SystemDefault: "",
                }
            )
        );

        setColourRows(
            createRows(
                "colour_map",
                materials.colour_map,
                colour_columns(autocompleteOptions, colourMapKeys, colourArrayKeys),
                colour_default
            )
        );

        setColourArrayRows(
            createRows(
                "colour_arrays",
                materials.colour_arrays,
                colour_array_columns(autocompleteOptions, colourMapKeys, colourArrayKeys),
                []
            )
        );
        setSlatRows(
            createRows(
                "SLATS",
                materials.SLATS,
                slat_columns(autocompleteOptions, colourMapKeys, colourArrayKeys),
                slat_default
            )
        );
        setInfillRows(
            createRows(
                "INFILLS",
                materials.INFILLS,
                infill_columns(autocompleteOptions, colourMapKeys, colourArrayKeys),
                infill_default
            )
        );
        setDownpipeRows(
            createRows(
                "DOWNPIPES",
                materials.DOWNPIPES,
                downpipe_columns(autocompleteOptions, colourMapKeys, colourArrayKeys),
                downpipe_default
            )
        );
        setGutterRows(
            createRows(
                "GUTTERS",
                materials.GUTTERS,
                gutter_columns(autocompleteOptions, colourMapKeys, colourArrayKeys),
                gutter_default
            )
        );
        setBeamRows(
            createRows(
                "BEAMS",
                materials.BEAMS,
                beam_colummns(autocompleteOptions, colourMapKeys, colourArrayKeys),
                beam_default
            )
        );
        setPostRows(
            createRows(
                "POSTS",
                materials.POSTS,
                post_columns(autocompleteOptions, colourMapKeys, colourArrayKeys),
                post_default
            )
        );
        setSheetRows(
            createRows(
                "SHEETS",
                materials.SHEETS,
                sheet_columns(autocompleteOptions, colourMapKeys, colourArrayKeys),
                post_default
            )
        );
    }, [materials, autocompleteOptions, colourArrayKeys, saving, showVariations]);

    const saveValue = (section, key, row, parameter, value, parameter2 = null, value2) => {
        setEditCell(null);
        setValue("");
        setValue2("");

        if (!row) {
            return;
        }

        if (parameter === "Key" && value === key) {
            window.saving[section + "_" + key] = null;
            setSaving({ ...window.saving });
            return;
        }
        if (parameter2 && row[parameter] === value && row[parameter2] === value2) {
            window.saving[section + "_" + key] = null;
            setSaving({ ...window.saving });
            return;
        }
        if (
            parameter !== "DELETE" &&
            parameter !== "ADD" &&
            parameter !== "EDIT" &&
            parameter !== "ARRAY_DATA" &&
            row[parameter] === value &&
            parameter2 === null
        ) {
            window.saving[section + "_" + key] = null;
            setSaving({ ...window.saving });
            return;
        }

        let new_row = Array.isArray(row) ? [...row] : { ...row };

        window.saving[section + "_" + key] = parameter;
        setSaving({ ...window.saving });

        let api_url = API_BASE() + "admin/UpdateMaterials?action=Update_" + parameter.replaceAll(" ", "_");

        if (parameter === "ARRAY_DATA") {
            api_url = API_BASE() + "admin/UpdateMaterials?action=ARRAY_DATA";
            new_row = row;
            value = row;
        } else if (parameter === "DELETE") {
            api_url = API_BASE() + "admin/UpdateMaterials?action=delete";
        } else if (parameter === "ADD") {
            if (materials[section][value] != null) {
                window.saving[section + "_" + key] = null;
                setSaving({ ...window.saving });
                return;
            }
            api_url = API_BASE() + "admin/UpdateMaterials?action=add";

            if (key.endsWith("|Variations")) {
                window.saving[section + "_" + key.replace("|Variations", "")] = parameter;
                setSaving({ ...window.saving });
            }
        } else {
            if (new_row[parameter.replaceAll(" ", "_")] !== undefined) parameter = parameter.replaceAll(" ", "_");
            new_row[parameter] = value;
            if (value === null || (value === "" && new_row[parameter] !== undefined)) {
                delete new_row[parameter];
            }
            if (parameter2) new_row[parameter2] = value2;
        }

        fetchTimeout(api_url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                section: section,
                key: key,
                value: value,
                row: new_row,
            }),
        })
            .then(async (response) => {
                if (response.status >= 200 && response.status <= 300) {
                    let newMaterials = await response.json();

                    setMaterials(newMaterials);
                } else {
                    throw "Error saving values";
                }
                window.saving[section + "_" + key] = null;
                setSaving({ ...window.saving });

                if (key.endsWith("|Variations")) {
                    window.saving[section + "_" + key.replace("|Variations", "")] = null;
                    setSaving({ ...window.saving });
                }
            })
            .catch((e) => {
                // setSaving({ ...saving, [row.id]: "Error:" + saving[row.id] });
                window.saving[section + "_" + key] = "Error:" + window.saving[section + "_" + key];
                setSaving({ ...window.saving });

                if (key.endsWith("|Variations")) {
                    window.saving[section + "_" + key.replace("|Variations", "")] =
                        "Error:" + window.saving[section + "_" + key];
                    setSaving({ ...window.saving });
                }
            });
    };

    function padTo2Digits(num) {
        return num.toString().padStart(2, "0");
    }

    function formatDate(date) {
        return [padTo2Digits(date.getDate()), padTo2Digits(date.getMonth() + 1), date.getFullYear()].join("-");
    }

    const DownloadOfferingFile = () => {
        var element = document.createElement("a");
        element.setAttribute(
            "href",
            "data:text/plain;charset=utf-8," + encodeURIComponent(JSON.stringify(materials, null, 4))
        );
        element.setAttribute("download", "MATERIALS.SETTINGS." + formatDate(new Date()) + ".json");

        element.style.display = "none";
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    };

    const dragOver = (e) => {
        let newvalue2 = { ...value2 };
        newvalue2.background = "#111111AA";
        setValue2(newvalue2);
        e.preventDefault();
    };
    const dragLeave = (e) => {
        let newvalue2 = { ...value2 };
        newvalue2.background = "rgb(134 134 134 / 36%)";
        setValue2(newvalue2);
        e.preventDefault();
    };
    const fileDrop = (e) => {
        let newvalue2 = { ...value2 };
        newvalue2.background = "rgb(134 134 134 / 36%)";
        setValue2(newvalue2);
        e.preventDefault();
        const files = e.dataTransfer.files;

        if (files.length) {
            handleFiles(files);
        }
    };

    const uploadFile = (e) => {
        if (e?.target?.files) handleFiles(e.target.files);
    };

    const handleFiles = (files) => {
        if (files.length === 0) return;
        let file = files[0];
        if (
            file.name.toLowerCase().endsWith(".png") ||
            file.name.toLowerCase().endsWith(".jpg") ||
            file.name.toLowerCase().endsWith(".gif")
        ) {
            if (file.size > 10000) {
                alert("File is too big! Less thank 10kB please");
                return;
            }

            var reader = new FileReader();
            reader.onload = function (e) {
                setValue(e.target.result);
            };
            reader.readAsDataURL(file);
        }
    };

    let editCellType = "None";
    let editCellHelperText = "";
    if (editCell?.column?.editor === undefined) {
        if (editCell?.column?.id) editCellType = "Text";
        if (editCell?.column?.autoComplete) editCellType = "Autocomplete";
        if (editCell?.column?.select) editCellType = "Select";
        if (editCell?.column?.id === "thumbnail") editCellType = "Thumbnail";

        if (editCell?.row?.[editCell?.column?.id]) {
            if (editCell?.column?.format)
                editCellHelperText =
                    "currently: " + editCell?.column?.format(editCell?.row?.[editCell?.column?.id], editCell?.row);
            else editCellHelperText = "currently: " + editCell?.row?.[editCell?.column?.id];
        }

        if (editCell?.column?.helperText) {
            editCellHelperText += " ... " + editCell?.column?.helperText;
        }
    }

    let autoComplete_list = null;
    if (editCell?.column?.autoComplete && typeof editCell?.column?.autoComplete === "object") {
        if (Array.isArray(editCell?.column?.autoComplete)) autoComplete_list = editCell?.column?.autoComplete;
        else autoComplete_list = Object.keys(editCell?.column?.autoComplete);
    }

    // let num_in_this_group = -1;
    // let header_i = 0;
    // for (let column of beam_colummns()) {
    //     if (column?.hideInTable) continue;
    //     let this_grouping = column?.grouping;
    //     if (this_grouping !== last_grouping || (this_grouping === undefined && last_grouping)) {
    //         //change in grouping. print cell

    //         let cell_style = {};
    //         if (header_i % 2 === 0) cell_style.background = "#936a2b !important";

    //         beam_grouping_headers.push(
    //             <TableCell
    //                 key={column.id}
    //                 className={
    //                     (last_grouping ? classes.categoryHeadingCell : classes.categoryHeadingCellBlank) +
    //                     " " +
    //                     classes.headingCell
    //                 }
    //                 style={cell_style}
    //                 colSpan={num_in_this_group + 1}
    //             >
    //                 {last_grouping ? last_grouping : ""}
    //             </TableCell>
    //         );
    //         header_i++;
    //         last_grouping = this_grouping;
    //         num_in_this_group = 0;
    //     } else {
    //         num_in_this_group++;
    //     }
    // }

    // if (num_in_this_group > 0) {
    //     let cell_style = {};
    //     if (header_i % 2 === 0) cell_style.background = "#936a2b !important";

    //     beam_grouping_headers.push(
    //         <TableCell
    //             key={"beam_col_end"}
    //             className={
    //                 (last_grouping ? classes.categoryHeadingCell : classes.categoryHeadingCellBlank) +
    //                 " " +
    //                 classes.headingCell
    //             }
    //             colSpan={num_in_this_group - 1}
    //         >
    //             {last_grouping ? last_grouping : ""}
    //         </TableCell>
    //     );
    // }

    return (
        <div className={classes.root}>
            {!intialise && <LinearProgress />}
            {materials && (
                <>
                    {/* <BSL_Button onClick={DownloadOfferingFile}>Download Current Materials File</BSL_Button>
                    <JsonView
                        data={materials}
                        shouldInitiallyExpand={(level) => {
                            if (level <= 0) return true;
                            else return false;
                        }}
                        style={darkStyles}
                    /> */}

                    <AppBar position="static" color="default">
                        <Tabs
                            value={tab}
                            onChange={(event, newValue) => setTab(newValue)}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            aria-label="full width tabs example"
                        >
                            <Tab label="Sheets" {...a11yProps(0)} />
                            <Tab label="Beams" {...a11yProps(1)} />
                            <Tab label="Posts" {...a11yProps(2)} />
                            <Tab label="Gutters" {...a11yProps(3)} />
                            <Tab label="Downpipes" {...a11yProps(4)} />
                            <Tab label="Slats" {...a11yProps(5)} />
                            <Tab label="Infills" {...a11yProps(6)} />
                            <Tab label="Colour Arrays" {...a11yProps(7)} />
                            <Tab label="Colours" {...a11yProps(8)} />
                            <Tab label="CAD Settings" {...a11yProps(9)} />
                        </Tabs>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                        index={tab}
                        onChangeIndex={(index) => setTab(index)}
                    >
                        <TabPanel value={tab} index={0} dir={theme.direction}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>{getGroupHeaders(sheet_columns)}</TableRow>
                                        <TableRow className={classes.headingRow}>
                                            {sheet_columns().map((column) =>
                                                column?.hideInTable ? null : (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={
                                                            column?.headerStyle ? column?.headerStyle : column?.style
                                                        }
                                                        className={classes.headingCell}
                                                    >
                                                        {column.label.replaceAll("_", " ")}
                                                    </TableCell>
                                                )
                                            )}
                                            {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                            <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>{sheetRows}</TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                        <TabPanel value={tab} index={1} dir={theme.direction}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>{getGroupHeaders(beam_colummns)}</TableRow>
                                        <TableRow className={classes.headingRow}>
                                            {beam_colummns().map((column) =>
                                                column?.hideInTable ? null : (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={
                                                            column?.headerStyle ? column?.headerStyle : column?.style
                                                        }
                                                        className={classes.headingCell}
                                                    >
                                                        {column.label.replaceAll("_", " ")}
                                                    </TableCell>
                                                )
                                            )}
                                            {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                            <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>{beamRows}</TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                        <TabPanel value={tab} index={2} dir={theme.direction}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>{getGroupHeaders(post_columns)}</TableRow>
                                        <TableRow className={classes.headingRow}>
                                            {post_columns().map((column) =>
                                                column?.hideInTable ? null : (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={
                                                            column?.headerStyle ? column?.headerStyle : column?.style
                                                        }
                                                        className={classes.headingCell}
                                                    >
                                                        {column.label.replaceAll("_", " ")}
                                                    </TableCell>
                                                )
                                            )}
                                            {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                            <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>{postRows}</TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                        <TabPanel value={tab} index={3} dir={theme.direction}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>{getGroupHeaders(gutter_columns)}</TableRow>
                                        <TableRow className={classes.headingRow}>
                                            {gutter_columns().map((column) =>
                                                column?.hideInTable ? null : (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={
                                                            column?.headerStyle ? column?.headerStyle : column?.style
                                                        }
                                                        className={classes.headingCell}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                )
                                            )}
                                            {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                            <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>{gutterRows}</TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                        <TabPanel value={tab} index={4} dir={theme.direction}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>{getGroupHeaders(downpipe_columns)}</TableRow>
                                        <TableRow className={classes.headingRow}>
                                            {downpipe_columns().map((column) =>
                                                column?.hideInTable ? null : (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={
                                                            column?.headerStyle ? column?.headerStyle : column?.style
                                                        }
                                                        className={classes.headingCell}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                )
                                            )}
                                            {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                            <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>{downpipeRows}</TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                        <TabPanel value={tab} index={5} dir={theme.direction}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>{getGroupHeaders(slat_columns)}</TableRow>
                                        <TableRow className={classes.headingRow}>
                                            {slat_columns().map((column) =>
                                                column?.hideInTable ? null : (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={
                                                            column?.headerStyle ? column?.headerStyle : column?.style
                                                        }
                                                        className={classes.headingCell}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                )
                                            )}
                                            {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                            <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>{slatRows}</TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                        <TabPanel value={tab} index={6} dir={theme.direction}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>{getGroupHeaders(infill_columns)}</TableRow>
                                        <TableRow className={classes.headingRow}>
                                            {infill_columns().map((column) =>
                                                column?.hideInTable ? null : (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={
                                                            column?.headerStyle ? column?.headerStyle : column?.style
                                                        }
                                                        className={classes.headingCell}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                )
                                            )}
                                            {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                            <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>{infillRows}</TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                        <TabPanel value={tab} index={7} dir={theme.direction}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow style={{ minHeight: "15px", height: "15px" }}>
                                            {getGroupHeaders(colour_array_columns)}
                                        </TableRow>
                                        <TableRow className={classes.headingRow}>
                                            {colour_array_columns().map((column) =>
                                                column?.hideInTable ? null : (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={
                                                            column?.headerStyle ? column?.headerStyle : column?.style
                                                        }
                                                        className={classes.headingCell}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                )
                                            )}
                                            {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                            <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>{colourArrayRows}</TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                        <TabPanel value={tab} index={8} dir={theme.direction}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>{getGroupHeaders(colour_columns)}</TableRow>
                                        <TableRow className={classes.headingRow}>
                                            {colour_columns().map((column) =>
                                                column?.hideInTable ? null : (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={
                                                            column?.headerStyle ? column?.headerStyle : column?.style
                                                        }
                                                        className={classes.headingCell}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                )
                                            )}
                                            {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                            <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>{colourRows}</TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                        <TabPanel value={tab} index={9} dir={theme.direction}>
                            <TableContainer className={classes.container}>
                                <Table stickyHeader size="small" aria-label="sticky table">
                                    <TableHead>
                                        <TableRow>{getGroupHeaders(default_cad_settings_columns)}</TableRow>
                                        <TableRow className={classes.headingRow}>
                                            {default_cad_settings_columns().map((column) =>
                                                column?.hideInTable ? null : (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                        style={
                                                            column?.headerStyle ? column?.headerStyle : column?.style
                                                        }
                                                        className={classes.headingCell}
                                                    >
                                                        {column.label}
                                                    </TableCell>
                                                )
                                            )}
                                            {/* <TableCell key={"Edit"} className={classes.headingCell}></TableCell> */}
                                            <TableCell key={"Options"} className={classes.headingCell}></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>{defaultCADSettingsRows}</TableBody>
                                </Table>
                            </TableContainer>
                        </TabPanel>
                    </SwipeableViews>
                </>
            )}
            <Popper
                key={editCell}
                anchorEl={editCell?.anchorEl}
                placement="bottom-start"
                open={editCell?.anchorEl}
                disablePortal={false}
                modifiers={{
                    flip: {
                        enabled: true,
                    },
                    preventOverflow: {
                        enabled: true,
                        boundariesElement: "scrollParent",
                    },
                    arrow: {
                        enabled: true,
                        element: editCell?.anchorEl,
                    },
                }}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
                    <Paper
                        style={{
                            padding: "0px 5px 5px 5px",
                            background: "rgb(255 179 67 / 96%)",
                            textAlign: "center",
                            paddingTop: "2px",
                            minWidth: "50px",
                        }}
                    >
                        <div
                            id="draggable-dialog-title"
                            style={{
                                position: "absolute",
                                width: "100%",
                                height: "19px",
                            }}
                        >
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <div className={classes.drag_bar} />
                                <div className={classes.drag_bar} />
                                <div className={classes.drag_bar} />
                            </div>
                        </div>
                        <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={() => setEditCell(null)}
                            style={{ color: "white", position: "absolute", right: "5px" }}
                        >
                            <CloseIcon />
                        </IconButton>

                        {editCell?.column?.editor !== undefined &&
                            editCell?.column?.editor(
                                editCell.section,
                                editCell.key,
                                editCell?.row,
                                value,
                                setValue,
                                saveValue,
                                value2,
                                setValue2,
                                pricefileDescSummary,
                                materials,
                                setEditItem
                            )}

                        {editCellType === "Autocomplete" && (
                            <>
                                <Autocomplete
                                    items={autoComplete_list}
                                    shouldItemRender={(item, value) => {
                                        if (item.toLowerCase().startsWith(value.toLowerCase().substring(0, 4)))
                                            return true;
                                        if (item.toLowerCase().indexOf(value.toLowerCase()) > -1) return true;
                                        return false;
                                    }}
                                    getItemValue={(item) => item}
                                    autoHighlight={false}
                                    renderItem={(item, highlighted) => (
                                        <div
                                            key={item.id}
                                            style={{ backgroundColor: highlighted ? "#eee" : "transparent" }}
                                        >
                                            {item}
                                        </div>
                                    )}
                                    menuStyle={{
                                        zIndex: "999999",
                                        position: "absolute",
                                        backgroundColor: "whitesmoke",
                                        boxShadow: "1px 1px 4px",
                                        fontSize: "12px",
                                        left: "auto",
                                        top: "auto",
                                        marginLeft: "9px",
                                        // marginTop: "-33px",
                                        lineHeight: 1.4,
                                        width: "350px",
                                        textAlign: "left",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                    }}
                                    inputProps={{
                                        style: {
                                            font: "200 12px Univers45",
                                            width: "95%",
                                            padding: "4px 0px 4px 8px !important",
                                        },
                                    }}
                                    renderInput={(props) => {
                                        return (
                                            <BSL_TextInput
                                                label={editCell?.column?.label}
                                                style={{ width: "150px", color: "white" }}
                                                value={value}
                                                autoFocus
                                                tight={true}
                                                allCaps={editCell?.column?.allCaps}
                                                preValidate={editCell?.column?.validate}
                                                InputProps={{
                                                    style: { fontSize: "80%" },
                                                    ...props,
                                                }}
                                                onEnter={(e) =>
                                                    saveValue(
                                                        editCell.section,
                                                        editCell.key,
                                                        editCell.row,
                                                        editCell?.column?.id,
                                                        e.target.value
                                                    )
                                                }
                                                onChange={(value) => {
                                                    setValue(value);
                                                }}
                                                helperText={editCellHelperText}
                                            />
                                        );
                                    }}
                                    value={value}
                                    // onChange={(e) => setValue(e.target.value.split("-")[0].trim())}
                                    onSelect={(val) => setValue(val.split("-")[0].trim())}
                                />
                                <br />
                                {value2 !== "NO BUTTON" && (
                                    <BSL_Button
                                        onClick={() =>
                                            saveValue(
                                                editCell.section,
                                                editCell.key,
                                                editCell.row,
                                                editCell?.column?.id,
                                                value
                                            )
                                        }
                                    >
                                        UPDATE
                                    </BSL_Button>
                                )}
                            </>
                        )}

                        {editCellType === "Text" && (
                            <>
                                <BSL_TextInput
                                    label={editCell?.column?.label}
                                    style={{ width: "150px", color: "white" }}
                                    value={value}
                                    autoFocus
                                    tight={true}
                                    allCaps={editCell?.column?.allCaps}
                                    preValidate={editCell?.column?.validate}
                                    onEnter={(e) =>
                                        saveValue(
                                            editCell.section,
                                            editCell.key,
                                            editCell.row,
                                            editCell?.column?.id,
                                            e.target.value
                                        )
                                    }
                                    onChange={(value) => {
                                        setValue(value);
                                    }}
                                    helperText={editCellHelperText}
                                />

                                {value2 !== "NO BUTTON" && (
                                    <BSL_Button
                                        onClick={() =>
                                            saveValue(
                                                editCell.section,
                                                editCell.key,
                                                editCell.row,
                                                editCell?.column?.id,
                                                value
                                            )
                                        }
                                    >
                                        UPDATE
                                    </BSL_Button>
                                )}
                            </>
                        )}

                        {editCellType === "Select" && (
                            <>
                                <SegmentedButtonGroup
                                    label={editCell?.column?.label}
                                    style={
                                        editCell?.column?.selectStyle
                                            ? editCell?.column?.selectStyle
                                            : { width: "300px", flex: "none" }
                                    }
                                    value={value}
                                    tight={true}
                                    items={editCell?.column?.select}
                                    onChange={(e, val) => {
                                        setValue(val);
                                        e.stopPropagation();
                                    }}
                                    helperText={editCellHelperText}
                                />

                                {value2 !== "NO BUTTON" && (
                                    <BSL_Button
                                        onClick={() =>
                                            saveValue(
                                                editCell.section,
                                                editCell.key,
                                                editCell.row,
                                                editCell?.column?.id,
                                                value
                                            )
                                        }
                                    >
                                        UPDATE
                                    </BSL_Button>
                                )}
                            </>
                        )}

                        {editCellType === "Thumbnail" && (
                            <>
                                <BSL_ControlContainer
                                    label={"Image"}
                                    style={{ color: "white" }}
                                    tight={true}
                                    helperText={"max 10kb"}
                                >
                                    <IconButton
                                        aria-label="delete"
                                        size="small"
                                        onClick={() => setValue("")}
                                        style={{
                                            color: "black",
                                            position: "absolute",
                                            right: "5px",
                                            marginTop: "12px",
                                        }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                    <input
                                        accept="image/gif, image/jpeg, image/png"
                                        // className={classes.input}
                                        style={{ display: "none" }}
                                        id="raised-button-file"
                                        type="file"
                                        onChange={uploadFile}
                                    />
                                    <label htmlFor="raised-button-file">
                                        <div
                                            onDragOver={dragOver}
                                            // onDragEnter={dragEnter}
                                            onDragLeave={dragLeave}
                                            onDrop={fileDrop}
                                            style={{
                                                background: value2?.background
                                                    ? value2?.background
                                                    : "rgb(134 134 134 / 36%)",
                                                cursor: "pointer",
                                                textAlign: "center",
                                            }}
                                        >
                                            <div
                                                className="checkerBG"
                                                style={{
                                                    backgroundColor: "white",
                                                    minHeight: "50px",
                                                }}
                                            >
                                                <img
                                                    style={{
                                                        maxHeight: "50px",
                                                        maxWidth: "150px",
                                                        textAlign: "center",
                                                    }}
                                                    src={value}
                                                />
                                            </div>

                                            <div
                                                style={{
                                                    textAlign: "center",
                                                    color: "white",
                                                    fontSize: "12px",
                                                    height: "50px",
                                                }}
                                            >
                                                {"Click or Drag & Drop image file to upload"}
                                            </div>
                                        </div>
                                    </label>
                                </BSL_ControlContainer>

                                <BSL_Button
                                    onClick={() =>
                                        saveValue(
                                            editCell.section,
                                            editCell.key,
                                            editCell.row,
                                            editCell?.column?.id,
                                            value
                                        )
                                    }
                                >
                                    UPDATE
                                </BSL_Button>
                            </>
                        )}
                    </Paper>
                </Draggable>
            </Popper>
        </div>
    );
}
